export const ACTIVE_LIST_ADD = "ACTIVE_LIST/ADD";
export const ACTIVE_LIST_CLEAR = "ACTIVE_LIST/CLEAR";
export const ACTIVE_LIST_ENTRIES_FAILURE = "ACTIVE_LIST/ENTRIES/FAILURE";
export const ACTIVE_LIST_ENTRIES_REQUEST = "ACTIVE_LIST/ENTRIES/REQUEST";
export const ACTIVE_LIST_ENTRIES_SUCCESS = "ACTIVE_LIST/ENTRIES/SUCCESS";
export const ACTIVE_LIST_REMOVE = "ACTIVE_LIST/REMOVE";
export const ACTIVE_LIST_REMOVE_FAILURE = "ACTIVE_LIST/REMOVE/FAILURE";
export const ACTIVE_LIST_REMOVE_REQUEST = "ACTIVE_LIST/REMOVE/REQUEST";
export const ACTIVE_LIST_REMOVE_SUCCESS = "ACTIVE_LIST/REMOVE/SUCCESS";
export const ACTIVE_LIST_SET = "ACTIVE_LIST/SET";
export const ANALYTICS_TRACK = "ANALYTICS/TRACK";
export const APP_LEGACY_LOADED = "APP/LEGACY/LOADED";
export const APP_LOGIN_DIALOG_SHOW = "APP/LOGIN_DIALOG/SHOW";
export const APP_MENU_STATE = "APP/MENU_STATE";
export const APP_SIDE_PANEL_TOGGLE = "APP/SIDE_PANEL/TOGGLE";
export const APP_VIEWPORT = "APP/VIEWPORT";
export const APP_WORKING_ORDER_TOGGLE = "APP/WORKING_ORDER/TOGGLE";
export const ATTACHMENT_ADD = "ATTACHMENT/ADD";
export const ATTACHMENT_FETCH_SUCCESS = "ATTACHMENTS/FETCH/SUCCESS";
export const ATTACHMENT_REMOVE = "ATTACHMENT/REMOVE";
export const ATTACHMENT_SUCCESS = "ATTACHMENT/SUCCESS";
export const BRAND_BARCODE_FIELDS_UPDATE = "BRAND/BARCODE_FIELDS/UPDATE";
export const BRAND_CATEGORIES_FAILURE = "BRAND_CATEGORIES/FAILURE";
export const BRAND_CATEGORIES_REQUEST = "BRAND_CATEGORIES/REQUEST";
export const BRAND_CATEGORIES_SUCCESS = "BRAND_CATEGORIES/SUCCESS";
export const BRAND_GENERIC_UPDATE_COMPLETE = "BRAND/GENERIC_UPDATE/COMPLETE";
export const BRAND_ADMIN_UPDATE_EMAIL_IMAGE_START = "BRAND/ADMIN_UPDATE_EMAIL_IMAGE/START";
export const BRAND_ADMIN_UPDATE_PERMISSIONS = "BRAND/ADMIN_UPDATE_PERMISSIONS/START";
export const BRAND_ADMIN_UPDATE_PERMISSIONS_COMPLETE = "BRAND/ADMIN_UPDATE_PERMISSIONS/COMPLETE";
export const BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS = "BRAND/ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS/START";
export const BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS_COMPLETE =
    "BRAND/ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS/COMPLETE";
export const BRAND_PROFILES_FILTER_MUTATE = "BRAND_PROFILES/FILTER_MUTATE";
export const BRAND_PROFILES_FILTER_ITEM_MUTATE = "BRAND_PROFILES/FILTER_ITEM_MUTATE";
export const BRAND_PROFILES_REQUEST = "BRAND_PROFILES/REQUEST";
export const BRAND_PROFILES_SUGGESTIONS = "BRAND_PROFILES/SUGGESTIONS";
export const BRAND_PROFILES_CONNECTIONS = "BRAND_PROFILES/CONNECTIONS";
export const BRAND_PROFILES_REQUEST_COMPLETED = "BRAND_PROFILES/REQUEST_COMPLETED";
export const BRAND_PROFILE_CATALOGS_REQUEST = "BRAND_PROFILE/CATALOGS/REQUEST";
export const BRAND_PROFILE_CATALOGS_SUCCESS = "BRAND_PROFILE/CATALOGS/SUCCESS";
export const BRAND_PROFILE_CATALOGS_FAILURE = "BRAND_PROFILE/CATALOGS/FAILURE";
export const BRAND_PROFILE_CHANGE = "BRAND_PROFILE/CHANGE";
export const BRAND_PROFILE_CHANGE_FAILURE = "BRAND_PROFILE/CHANGE/FAILURE";
export const BRAND_PROFILE_CHANGE_SUCCESS = "BRAND_PROFILE/CHANGE/SUCCESS";
export const BRAND_PROFILE_EVENTS_DELETE_SUCCESS = "BRAND_PROFILE/EVENTS/DELETE/SUCCESS";
export const BRAND_PROFILE_EVENTS_SUCCESS = "BRAND_PROFILE/EVENTS/SUCCESS";
export const BRAND_PROFILE_EVENTS_UPDATE_SUCCESS = "BRAND_PROFILE/EVENTS/UPDATE/SUCCESS";
export const BRAND_PROFILE_FAILURE = "BRAND_PROFILE/FAILURE";
export const BRAND_PROFILE_PICTURES_CHANGE = "BRAND_PROFILE/PICTURES/CHANGE";
export const BRAND_PROFILE_PICTURES_FAILURE = "BRAND_PROFILE/PICTURES/FAILURE";
export const BRAND_PROFILE_PICTURE_CHANGE = "BRAND_PROFILE/PICTURE/CHANGE";
export const BRAND_PROFILE_PICTURE_CHANGE_COMPLETE = "BRAND_PROFILE/PICTURE/CHANGE/COMPLETE";
export const BRAND_PROFILE_REQUEST = "BRAND_PROFILE/REQUEST";
export const BRAND_PROFILE_RESET = "BRAND_PROFILE/RESET";
export const BRAND_PROFILE_SUCCESS = "BRAND_PROFILE/SUCCESS";

export const BRAND_WAREHOUSE_CREATE = "BRAND/WAREHOUSE/CREATE";
export const BRAND_WAREHOUSE_DELETE = "BRAND/WAREHOUSE/DELETE";
export const BRAND_WAREHOUSE_UPDATE = "BRAND/WAREHOUSE/UPDATE";
export const BRAND_WAREHOUSE_UPDATE_COMPLETE = "BRAND/WAREHOUSE/UPDATE/COMPLETE";
export const BRAND_WAREHOUSE_DELETE_COMPLETE = "BRAND/WAREHOUSE/DELETE/COMPLETE";
export const BRAND_WAREHOUSE_COMPLETE = "BRAND/WAREHOUSE/COMPLETE";

export const BRAND_GROUPS_UPDATE = "BRAND/GROUPS/UPDATE";
export const BRAND_GROUPS_UPDATE_COMPLETED = "BRAND/GROUPS/UPDATED/COMPLETED";

export const BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE = "BRAND/GUEST_BUYER_WHITELIST_PRODUCT_VALUES/UPDATE";
export const BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE_COMPLETED =
    "BRAND/GUEST_BUYER_WHITELIST_PRODUCT_VALUES/UPDATED/COMPLETED";

export const BRAND_PREFERENCES_UPDATE = "BRAND/PREFERENCES/UPDATE";
export const BRAND_PREFERENCES_UPDATE_COMPLETE = "BRAND/PREFERENCES/UPDATE/COMPLETE";

export const BRAND = {
    ORDER_SETTINGS: {
        UPDATE: progressTypes("BRAND/ORDER_SETTINGS", "UPDATE"),
    },
    LEGAL_FILES: {
        FETCH: progressTypes("BRAND/ORDER_LEGAL_FILES"),
        ADD: progressTypes("BRAND/ORDER_LEGAL_FILES", "ADD"),
        DELETE: progressTypes("BRAND/ORDER_LEGAL_FILES", "DELETE"),
        REPLACE: progressTypes("BRAND/ORDER_LEGAL_FILES", "REPLACE"),
        UPDATE: progressTypes("BRAND/ORDER_LEGAL_FILES", "UPDATE"),
    },
};

export const BRAND_SETTINGS_UPDATE = "BRAND/SETTINGS/UPDATE";
export const BRAND_SETTINGS_UPDATE_COMPLETE = "BRAND/SETTINGS/UPDATE/COMPLETE";

export const BRAND_SECRETS_UPDATE = "BRAND/SECRETS/UPDATE";
export const BRAND_SECRETS_UPDATE_COMPLETE = "BRAND/SECRETS/UPDATE/COMPLETE";

export const BRAND_ORDER_TERMS_UPDATE = "BRAND/ORDER_TERMS/UPDATE";
export const BRAND_ORDER_TERMS_UPDATE_COMPLETE = "BRAND/ORDER_TERMS/UPDATE/COMPLETE";

export const BRAND_REORDER_EXCLUSIONS_UPDATE = "BRAND/REORDER_EXCLUSIONS/UPDATE";
export const BRAND_REORDER_EXCLUSIONS_UPDATE_COMPLETE = "BRAND/REORDER_EXCLUSIONS/UPDATE/COMPLETE";

export const BRAND_SPLIT_FIELDS_UPDATE = "BRAND/SPLIT_FIELDS/UPDATE";
export const BRAND_SPLIT_FIELDS_UPDATE_COMPLETE = "BRAND/SPLIT_FIELDS/UPDATE/COMPLETE";

export const BRAND_ORDER_RECAP_UPDATE = progressTypes("BRAND/ORDER_RECAP", "UPDATE");

export const BRAND_PREBOOK_FIELDS_UPDATE = "BRAND/PREBOOK_FIELDS/UPDATE";
export const BRAND_PREBOOK_FIELDS_UPDATE_COMPLETE = "BRAND/PREBOOK_FIELDS/UPDATE/COMPLETE";

export const BRAND_SHIPPING_ACCOUNTS_REQUEST = "BRAND/SHIPPING_ACCOUNTS/REQUEST";
export const BRAND_SHIPPING_ACCOUNTS_FETCH_COMPLETE = "BRAND/SHIPPING_ACCOUNTS/COMPLETE";

export const BRAND_AVAILABLE_SHIPPING_CARRIERS_REQUEST = "BRAND/AVAILABLE_SHIPPING_CARRIERS/REQUEST";
export const BRAND_AVAILABLE_SHIPPING_CARRIERS_COMPLETE = "BRAND/AVAILABLE_SHIPPING_CARRIERS/COMPLETE";

export const BRAND_SHIPPING_CARRIER_REQUEST = "SHIPPING_ACCOUNT_CARRIER/REQUEST";
export const BRAND_SHIPPING_CARRIER_COMPLETE = "SHIPPING_ACCOUNT_CARRIER/COMPLETE";
export const SHIPPING_ACCOUNT_CARRIERS_RESET = "SHIPPING_ACCOUNT_CARRIERS/RESET";
export const SHIPPING_ACCOUNT_CARRIERS_REQUEST = "SHIPPING_ACCOUNT_CARRIERS/REQUEST";
export const SHIPPING_ACCOUNT_CARRIERS_REQUEST_COMPLETE = "SHIPPING_ACCOUNT_CARRIERS/COMPLETE";
export const SHIPPING_ACCOUNT_CARRIER_CREATE = "SHIPPING_ACCOUNT_CARRIER/CREATE";
export const SHIPPING_ACCOUNT_CARRIER_CREATE_COMPLETE = "SHIPPING_ACCOUNT_CARRIER/CREATE/COMPLETE";
export const SHIPPING_ACCOUNT_CARRIER_UPDATE = "SHIPPING_ACCOUNT_CARRIER/UPDATE";
export const SHIPPING_ACCOUNT_CARRIER_UPDATE_COMPLETE = "SHIPPING_ACCOUNT_CARRIER/UPDATE/COMPLETE";
export const SHIPPING_ACCOUNT_CARRIER_DELETE = "SHIPPING_ACCOUNT_CARRIER/DELETE";
export const SHIPPING_ACCOUNT_CARRIER_DELETE_COMPLETE = "SHIPPING_ACCOUNT_CARRIER/DELETE/COMPLETE";

export const SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_REQUEST = "SHIPPING/CARRIER/WAREHOUSE_SERVICES/REQUEST";
export const SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_RESET = "SHIPPING/CARRIER/WAREHOUSE_SERVICES/RESET";
export const SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_COMPLETE = "SHIPPING/CARRIER/WAREHOUSE_SERVICES/COMPLETE";
export const SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_SET = "SHIPPING/CARRIER/WAREHOUSE_SERVICES/SET";
export const SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_SET_COMPLETE =
    "SHIPPING/CARRIER/WAREHOUSE_SERVICES/SET/COMPLETE";

export const BRAND_SHIPPING_ACCOUNT_CREATE = "BRAND/SHIPPING_ACCOUNT/CREATE";
export const BRAND_SHIPPING_ACCOUNT_CREATE_COMPLETE = "BRAND/SHIPPING_ACCOUNT/CREATE/COMPLETE";

export const SHIPPING_CARRIER_SERVICES_REQUEST = "SHIPPING/CARRIER/SERVICES/REQUEST";
export const SHIPPING_CARRIER_SERVICES_COMPLETE = "SHIPPING/CARRIER/SERVICES/COMPLETE";

export const SHIPPING_PROMOTIONS_REQUEST = "SHIPPING/PROMOTIONS/REQUEST";
export const SHIPPING_PROMOTIONS_COMPLETE = "SHIPPING/PROMOTIONS/COMPLETE";
export const SHIPPING_PROMOTIONS_UPDATE = "SHIPPING/PROMOTIONS/UPDATE";
export const SHIPPING_PROMOTIONS_RESET = "SHIPPING/PROMOTIONS/RESET";
export const SHIPPING_PROMOTION_REQUEST = "SHIPPING/PROMOTION/REQUEST";
export const SHIPPING_PROMOTION_COMPLETE = "SHIPPING/PROMOTION/COMPLETE";
export const SHIPPING_PROMOTION_DELETE = "SHIPPING/PROMOTION/DELETE";
export const SHIPPING_PROMOTION_DELETE_COMPLETE = "SHIPPING/PROMOTION/DELETE/COMPLETE";

export const BULK_ITEMS_ADD = "BULK_ITEMS/ADD";
export const BULK_ITEMS_CLEAR = "BULK_ITEMS/CLEAR";
export const BULK_ITEMS_DESELECT_ALL = "BULK_ITEMS/DESELECT_ALL";
export const BULK_ITEMS_REMOVE = "BULK_ITEMS/REMOVE";
export const BULK_ITEMS_SELECT_ALL = "BULK_ITEMS/SELECT_ALL";
export const BULK_ITEMS_SELECT = "BULK_ITEMS/SELECT";

export const BULK_MANAGER = {
    OPEN: "BULK_MANAGER/OPEN",
    CLOSE: "BULK_MANAGER/CLOSE",
    ADD: "BULK_MANAGER/ADD",
    REMOVE: "BULK_MANAGER/REMOVE",
    SET_BULK_JOBS: "BULK_MANAGER/SET_BULK_JOBS",
};

export const BUYER_DASHBOARD_FETCH = "BUYER_DASHBOARD/FETCH";
export const BUYER_DASHBOARD_FETCH_COMPLETED = "BUYER_DASHBOARD/FETCH/COMPLETED";
export const BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH = "BUYER_DASHBOARD/CONNECTED_BRANDS/FETCH";
export const BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_COMPLETED = "BUYER_DASHBOARD/CONNECTED_BRANDS/FETCH/COMPLETED";
export const BUYER_DASHBOARD_RECENT_ORDERS_FETCH = "BUYER_DASHBOARD/RECENT_ORDERS/FETCH";
export const BUYER_DASHBOARD_RECENT_ORDERS_FETCH_COMPLETED = "BUYER_DASHBOARD/RECENT_ORDERS/FETCH/COMPLETED";
export const BUYER_DASHBOARD_RECENT_ORDERS_FILTER = "BUYER_DASHBOARD/RECENT_ORDERS/FILTER";
export const BUYER_DASHBOARD_RECENT_ORDERS_FILTER_COMPLETED = "BUYER_DASHBOARD/RECENT_ORDERS/FILTER/COMPLETED";
export const BUYER_DASHBOARD_RECENT_ORDERS_REORDER = "BUYER_DASHBOARD/RECENT_ORDERS/REORDER";
export const BUYER_DASHBOARD_RECENT_ORDERS_REORDER_COMPLETED = "BUYER_DASHBOARD/RECENT_ORDERS/REORDER/COMPLETED";
export const BUYER_DASHBOARD_RECENT_ORDERS_SEARCH = "BUYER_DASHBOARD/RECENT_ORDERS/SEARCH";
export const BUYER_DASHBOARD_RECENT_ORDERS_SEARCH_COMPLETED = "BUYER_DASHBOARD/RECENT_ORDERS/SEARCH/COMPLETED";

export const BUYER_DASHBOARD_RECENT_ORDERS_FETCH_CANCEL = "BUYER_DASHBOARD/RECENT_ORDERS/FETCH/CANCEL";
export const BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_CANCEL = "BUYER_DASHBOARD/CONNECTED_BRANDS/FETCH/CANCEL";
export const BUYER_DASHBOARD_RETAIL_INTEGRATIONS_PANEL_SET = "BUYER_DASHBOARD/RETAIL_INTEGRATIONS_PANEL/SET";

export const CAMPAIGNS_FAILURE = "CAMPAIGNS/FAILURE";
export const CAMPAIGNS_FILTER_CHANGE = "CAMPAIGNS/FILTER_OPTIONS/CHANGE";
export const CAMPAIGNS_FILTER_OPTIONS_FAILURE = "CAMPAIGNS/FILTER_OPTIONS/FAILURE";
export const CAMPAIGNS_FILTER_OPTIONS_REQUEST = "CAMPAIGNS/FILTER_OPTIONS/REQUEST";
export const CAMPAIGNS_FILTER_OPTIONS_SUCCESS = "CAMPAIGNS/FILTER_OPTIONS/SUCCESS";
export const CAMPAIGNS_REQUEST_START = "CAMPAIGNS/REQUEST/START";
export const CAMPAIGNS_RESULT = "CAMPAIGNS/RESULT";
export const CAMPAIGNS_SORT_CHANGE = "CAMPAIGNS/SORT/CHANGE";
export const CAMPAIGNS_SEARCH_CHANGE = "CAMPAIGNS/SEARCH/CHANGE";

export const CAMPAIGNS_EDIT_START = "CAMPAIGNS/EDIT/START";
export const CAMPAIGNS_EDIT_SUCCESS = "CAMPAIGNS/EDIT/SUCCESS";
export const CAMPAIGNS_EDIT_ERROR = "CAMPAIGNS/EDIT/ERROR";
export const CAMPAIGNS_ARCHIVE_CHANGE = "CAMPAIGNS/ARCHIVE/CHANGE";

export const CAMPAIGN_FETCH_START = "CAMPAIGN/FETCH/START";
export const CAMPAIGN_FETCH_FAILURE = "CAMPAIGN/FETCH/FAILURE";
export const CAMPAIGN_FETCH_SUCCESS = "CAMPAIGN/FETCH/SUCCESS";
export const CAMPAIGN_RESET = "CAMPAIGN/RESET";

export const CAMPAIGN_EDIT_START = "CAMPAIGN/EDIT/START";
export const CAMPAIGN_EDIT_SUCCESS = "CAMPAIGN/EDIT/SUCCESS";
export const CAMPAIGN_EDIT_ERROR = "CAMPAIGN/EDIT/ERROR";

export const CAMPAIGN_RECIPIENTS_FETCH_START = "CAMPAIGN_RECIPIENTS/FETCH/START";
export const CAMPAIGN_RECIPIENTS_FETCH_FAILURE = "CAMPAIGN_RECIPIENTS/FETCH/FAILURE";
export const CAMPAIGN_RECIPIENTS_FETCH_SUCCESS = "CAMPAIGN_RECIPIENTS/FETCH/SUCCESS";
export const CAMPAIGN_RECIPIENTS_FILTER_CHANGE = "CAMPAIGN_RECIPIENTS/FILTER/CHANGE";
export const CAMPAIGN_RECIPIENTS_SORT_CHANGE = "CAMPAIGN_RECIPIENTS/SORT/CHANGE";
export const CAMPAIGN_RECIPIENTS_SEARCH_CHANGE = "CAMPAIGN_RECIPIENTS/SEARCH/CHANGE";

export const CART_FAILURE = "CART/FAILURE";
export const CART_PRICING_FAILURE = "CART/PRICING/FAILURE";
export const CART_ITEM_ADD = "CART_ITEM/ADD";
export const CART_ITEM_FAILURE = "CART_ITEM/FAILURE";
export const CART_ITEM_REMOVE = "CART_ITEM/REMOVE";
export const CART_ITEM_REMOVE_VIA_LINE_ITEM_INDEX = "CART_ITEM/REMOVE_VIA_LINE_ITEM_INDEX";
export const CART_ITEM_REMOVE_FAILURE = "CART_ITEM/REMOVE/FAILURE";
export const CART_ITEM_REMOVE_REQUEST = "CART_ITEM/REMOVE/REQUEST";
export const CART_ITEM_REMOVE_SUCCESS = "CART_ITEM/REMOVE/SUCCESS";
export const CART_ITEM_REQUEST = "CART_ITEM/REQUEST";
export const CART_ITEM_SUCCESS = "CART_ITEM/SUCCESS";
export const CART_REQUEST = "CART/REQUEST";
export const CART_PRICING_REQUEST = "CART/PRICING/REQUEST";
export const CART_RETOGGLE = "CART/RETOGGLE";
export const CART_SUCCESS = "CART/SUCCESS";
export const CART_PRICING_SUCCESS = "CART/PRICING/SUCCESS";
export const CART_REDIRECT_AFTER_SUBMIT = "CART/REDIRECT_AFTER_SUBMIT";
export const CART_OPEN_CHECKOUT = "CART/OPEN_CHECKOUT";

export const CATALOGS_FAILURE = "CATALOGS/FAILURE";
export const CATALOGS_FILTERS = "CATALOGS/FILTERS";
export const CATALOGS_REQUEST = "CATALOGS/REQUEST";
export const CATALOGS_SUCCESS = "CATALOGS/SUCCESS";
export const CATALOGS_RESET = "CATALOGS/RESET";
export const CATALOG_ENTRIES_BULK_DELETE = "CATALOG_ENTRIES/BULK/DELETE";
export const CATALOG_ENTRIES_BULK_DELETE_SUCCESS = "CATALOG_ENTRIES/BULK/DELETE/SUCCESS`";
export const CATALOG_ENTRIES_CLEAR_ERROR = "CATALOG_ENTRIES/CLEAR_ERROR";
export const CATALOG_ENTRIES_FILTERS = "CATALOG_ENTRIES/FILTERS";
export const CATALOG_ENTRIES_REORDER = "CATALOG_ENTRIES/REORDER";
export const CATALOG_ENTRIES_REQUEST = "CATALOG_ENTRIES/REQUEST";
export const CATALOG_ENTRIES_REQUEST_COMPLETED = "CATALOG_ENTRIES/REQUEST/COMPLETED";
export const CATALOG_ENTRIES_RESET = "CATALOG_ENTRIES/RESET";
export const CATALOG_ENTRIES_REFRESH = "CATALOG_ENTRIES/REFRESH";
export const CATALOG_ENTRIES_RESULT = "CATALOG_ENTRIES/RESULT";
export const CATALOG_ENTRY_ADD_ERROR = "CATALOG/ENTRY/ADD/ERROR";
export const CATALOG_ENTRY_ADD_REQUEST = "CATALOG/ENTRY/ADD/REQUEST";
export const CATALOG_ENTRY_ADD_SUCCESS = "CATALOG/ENTRY/ADD/SUCCESS";
export const CATALOG_ENTRY_DELETE = "CATALOG/ENTRY/DELETE";
export const CATALOG_FAILURE = "CATALOGS/FAILURE";
export const CATALOG_REQUEST = "CATALOGS/REQUEST";
export const CATALOG_SUCCESS = "CATALOGS/SUCCESS";
export const CATALOG_UPDATE = "CATALOG/UPDATE";
export const CATALOG_RESET = "CATALOG/RESET";

export const CART_GRID_VIEW = {
    UPDATE: "CART_GRID_VIEW/UPDATE",
    ROWIDS: "CART_GRID_VIEW/ROWIDS/SET",
    SELECTED: {
        SET: "CART_GRID_VIEW/SELECTED/SET",
        DESELECT_ALL: "CART_GRID_VIEW/SELECTED/DESELECT_ALL",
        SHOW: "CART_GRID_VIEW/SIZES/SHOW_SELECTED",
        HIDE: "CART_GRID_VIEW/SIZES/HIDE_SELECTED",
    },
    SIZES_SHOWN_SET: "CART_GRID_VIEW/SIZES/SHOWN_SET",
    LOADING: "CART_GRID_VIEW/LOADING/SET",
    GRID_STATE: "CART_GRID_VIEW/GRID_STATE/SET",
    SEARCH_TEXT: "CART_GRID_VIEW/SEARCH_TEXT/SET",
    CLEAR: "CART_GRID_VIEW/CLEAR",
    CUSTOM_VIEWS: {
        FETCH: "CART_GRID_VIEW/CUSTOM_VIEWS/FETCH",
        CREATE: "CART_GRID_VIEW/CUSTOM_VIEWS/CREATE",
        UPDATE: "CART_GRID_VIEW/CUSTOM_VIEWS/UPDATE",
        DELETE: "CART_GRID_VIEW/CUSTOM_VIEWS/DELETE",
        SET: "CART_GRID_VIEW/CUSTOM_VIEWS/SET",
    },
};

export const CART_NOTIFICATIONS = {
    RESET: "CART_NOTIFICATIONS/RESET",
    SYNC: "CART_NOTIFICATIONS/SYNC",
    UPDATE: "CART_NOTIFICATIONS/UPDATE",
    ADD: "CART_NOTIFICATIONS/ADD",
    DISMISS: "CART_NOTIFICATIONS/DISMISS",
    REMOVE: "CART_NOTIFICATIONS/REMOVE",
};

export const WORKING_ORDER_STATE = {
    OPEN: "WORKING_ORDER_STATE/OPEN",
    CLOSE: "WORKING_ORDER_STATE/CLOSE",
    DATA: "WORKING_ORDER_STATE/DATA",
    LOAD: "WORKING_ORDER_STATE/LOAD",
    UPDATE: "WORKING_ORDER_STATE/UPDATE",
    REVIEW: {
        LOAD: "WORKING_ORDER_STATE/REVIEW/LOAD",
        UPDATE: "WORKING_ORDER_STATE/REVIEW/UPDATE",
    },
};

export const CONTACT_GROUP_FETCH_START = "CONTACT_GROUP/FETCH/START";
export const CONTACT_GROUP_FETCH_SUCCESS = "CONTACT_GROUP/FETCH/SUCCESS";
export const CONTACT_GROUP_FETCH_FAILURE = "CONTACT_GROUP/FETCH/FAILURE";
export const CONTACT_GROUP_EDIT_START = "CONTACT_GROUP/EDIT/START";
export const CONTACT_GROUP_EDIT_SUCCESS = "CONTACT_GROUP/EDIT/SUCCESS";
export const CONTACT_GROUP_EDIT_FAILURE = "CONTACT_GROUP/EDIT/FAILURE";
export const CONTACT_GROUP_TAB_CHANGE = "CONTACT_GROUP/TAB/CHANGE";
export const CONTACT_GROUP_CREATE = "CONTACT_GROUP/CREATE";
export const CONTACT_GROUP_CREATE_FAILURE = "CONTACT_GROUP/CREATE/FAILURE";
export const CONTACT_GROUP_CREATE_SUCCESS = "CONTACT_GROUP/CREATE/SUCCESS";
export const CONTACT_GROUP_RESET = "CONTACT_GROUP/RESET";

export const CONTACT_GROUP_RECIPIENTS_FETCH_FAILURE = "CONTACT_GROUP_RECIPIENTS/FETCH/FAILURE";
export const CONTACT_GROUP_RECIPIENTS_FETCH_START = "CONTACT_GROUP_RECIPIENTS/FETCH/START";
export const CONTACT_GROUP_RECIPIENTS_FETCH_SUCCESS = "CONTACT_GROUP_RECIPIENTS/FETCH/SUCCESS";
export const CONTACT_GROUP_RECIPIENTS_FILTER_CHANGE = "CONTACT_GROUP_RECIPIENTS/FILTER/CHANGE";
export const CONTACT_GROUP_RECIPIENTS_SORT_CHANGE = "CONTACT_GROUP_RECIPIENTS/SORT/CHANGE";
export const CONTACT_GROUP_RECIPIENTS_RESET = "CONTACT_GROUP_RECIPIENTS/RESET";
export const CONTACT_GROUP_RECIPIENTS_SEARCH_CHANGE = "CONTACT_GROUP_RECIPIENTS/SEARCH/CHANGE";

export const CONNECTION_REQUESTS_FAILURE = "CONNECTION_REQUESTS/FAILURE";
export const CONNECTION_REQUESTS_FILTER_CHANGE = "CONNECTION_REQUESTS/FILTER_CHANGE";
export const CONNECTION_REQUESTS_REQUEST_START = "CONNECTION_REQUESTS/REQUEST_START";
export const CONNECTION_REQUESTS_RESULT = "CONNECTION_REQUESTS/RESULT";
export const CONNECTION_REQUESTS_SORT_CHANGE = "CONNECTION_REQUESTS/SORT_CHANGE";
export const CONNECTION_REQUESTS_SEARCH_CHANGE = "CONNECTION_REQUESTS/SEARCH_CHANGE";
export const CONNECTION_REQUESTS_FOR_BUYER = "CONNECTION_REQUESTS/FOR_BUYER";
export const CONNECTION_REQUESTS_COUNT = "CONNECTION_REQUESTS/COUNT";
export const CONNECTION_REQUESTS_RETAILER_COMPANIES_START = "CONNECTION_REQUESTS/RETAILER_COMPANIES/START";
export const CONNECTION_REQUESTS_RETAILER_COMPANIES_SUCCESS = "CONNECTION_REQUESTS/RETAILER_COMPANIES/SUCCESS";
export const CONNECTION_REQUESTS_RETAILER_COMPANIES_FAILURE = "CONNECTION_REQUESTS/RETAILER_COMPANIES/FAILURE";

export const CONNECTION_REQUEST_EDIT_START = "CONNECTION_REQUEST/EDIT/START";
export const CONNECTION_REQUEST_EDIT_SUCCESS = "CONNECTION_REQUEST/EDIT/SUCCESS";
export const CONNECTION_REQUEST_EDIT_ERROR = "CONNECTION_REQUEST/EDIT/ERROR";

export const DASHBOARD_FETCH = "DASHBOARD/FETCH";
export const DASHBOARD_LINESHEETS_FETCHED = "DASHBOARD/LINESHEETS/FETCHED";

export const DASHBOARD = {
    MUTATE: "DASHBOARD/MUTATE",
    CLEAR: "DASHBOARD/CLEAR",
    PENDING_MEDIA: {
        CLEAR: "DASHBOARD/PENDING_MEDIA/CLEAR",
        UPLOADED: "DASHBOARD/PENDING_MEDIA/UPLOADED",
        ERROR: "DASHBOARD/PENDING_MEDIA/ERROR",
    },
};

export const SET_RECENTLY_TEXT_EDITOR = "TEXT_EDITOR/SET_RECENTLY";

export const DND_DRAG = "DND/DRAG";
export const DND_DROP = "DND/DROP";
export const EVENTS_FAILURE = "EVENTS/FAILURE";
export const EVENTS_REQUEST = "EVENTS/REQUEST";
export const EVENTS_SUCCESS = "EVENTS/SUCCESS";

export const FEATURED_CATALOGS_FETCH = "FEATURED/CATALOGS/FETCH";
export const FEATURED_CATALOGS_FETCH_CANCEL = "FEATURED/CATALOGS/FETCH/CANCEL";
export const FEATURED_CATALOGS_COMPLETED = "FEATURED/CATALOGS/COMPLETED";

export const FILTERS_REQUEST = "FILTERS/REQUEST";
export const FILTERS_FAILURE = "FILTERS/FAILURE";
export const FILTERS_SUCCESS = "FILTERS/SUCCESS";
export const FILTERS_CACHE_UPDATE = "FILTERS/CACHE_UPDATE";

export const INSTAGRAM_FEED_SUCCESS = "INSTAGRAM_FEED_SUCCESS";
export const INSTAGRAM_LINK_FAILURE = "INSTAGRAM_LINK_FAILURE";
export const INSTAGRAM_LINK_SUCCESS = "INSTAGRAM_LINK_SUCCESS";
export const INSTAGRAM_UNLINK_FAILURE = "INSTAGRAM_UNLINK_FAILURE";
export const INSTAGRAM_UNLINK_SUCCESS = "INSTAGRAM_UNLINK_SUCCESS";
export const ITEMS_FAILURE = "ITEMS/FAILURE";
export const ITEMS_FILTER_CHANGE = "ITEMS/FILTER/CHANGE";
export const ITEMS_FILTER_OPTIONS_FAILURE = "ITEMS/FILTER_OPTIONS/FAILURE";
export const ITEMS_FILTER_OPTIONS_REQUEST = "ITEMS/FILTER_OPTIONS/REQUEST";
export const ITEMS_FILTER_OPTIONS_SUCCESS = "ITEMS/FILTER_OPTIONS/SUCCESS";
export const ITEMS_REQUEST_START = "ITEMS/REQUEST/START";
export const ITEMS_RESET = "ITEMS/RESET";
export const ITEMS_RESULT = "ITEMS/RESULT";
export const ITEMS_SEARCH_CHANGE = "ITEMS/SEARCH/CHANGE";
export const ITEM_FAILURE = "ITEM/FAILURE";
export const ITEM_INVENTORY = "ITEM/INVENTORY";
export const ITEM_REQUEST = "ITEM/REQUEST";
export const ITEM_SET_CURRENT = "ITEM/SET_CURRENT";
export const ITEM_SUCCESS = "ITEM/SUCCESS";
export const ITEM_VARIENTS = "ITEM/VARIENTS";
export const ITEM_WAREHOUSE_AVAILABILITY = "ITEM/WAREHOUSE_AVAILABILITY";
export const ITEM_WAREHOUSE_CHANGE = "ITEM/WAREHOUSE/CHANGE";
export const ITEM_WAREHOUSE_REPLENISHMENT_GROUPS = "ITEM/WAREHOUSE/REPLENISHMENT_GROUPS";
export const LAUNCHDARKLY_UPDATE = "LAUNCHDARKLY/UPDATE";
export const LEGACY_LINKED_RETAILER_REQUEST = "LEGACY/LINKED_RETAILER/REQUEST";
export const LEGACY_LINKED_RETAILER_FAILURE = "LEGACY/LINKED_RETAILER/FAILURE";
export const LEGACY_LINKED_RETAILER_SUCCESS = "LEGACY/LINKED_RETAILER/SUCCESS";
export const LEGACY_REQUEST_ACCESS_REQUEST = "LEGACY/REQUEST_ACCESS/REQUEST";
export const LEGACY_REQUEST_ACCESS_COMPLETED = "LEGACY/REQUEST_ACCESS/COMPLETED";
export const PAGE_LEAVE = "PAGE/LEAVE";
export const PAGE_LAYOUT_FETCH = "PAGE_LAYOUT/FETCH";
export const PAGE_LAYOUTS_COMPLETE = "PAGE_LAYOUTS/COMPLETE";
export const PAGE_LAYOUTS_CREATE = "PAGE_LAYOUTS/CREATE";
export const PAGE_LAYOUTS_CREATE_COMPLETED = "PAGE_LAYOUTS/CREATE/COMPLETED";
export const PAGE_LAYOUTS_DELETE = "PAGE_LAYOUTS/DELETE";
export const PAGE_LAYOUTS_DELETE_COMPLETED = "PAGE_LAYOUTS/DELETE/COMPLETED";
export const PAGE_LAYOUTS_COPY = "PAGE_LAYOUTS/COPY";
export const PAGE_LAYOUTS_COPY_COMPLETED = "PAGE_LAYOUTS/COPY/COMPLETED";
export const PAGE_LAYOUTS_FETCH = "PAGE_LAYOUTS/FETCH";
export const PAGE_LAYOUTS_RESET = "PAGE_LAYOUTS/RESET";
export const PAGE_LAYOUTS_UPDATE = "PAGE_LAYOUTS/UPDATE";
export const PAGE_LAYOUTS_UPDATE_COMPLETED = "PAGE_LAYOUTS/UPDATE/COMPLETED";
export const PAGE_LAYOUTS_PAGE_CREATE = "PAGE_LAYOUTS/PAGE/CREATE";

export const PAYMENT_CONFIGURATIONS_SAVE = "PAYMENT_CONFIGURATIONS/SAVE";
export const PAYMENT_CONFIGURATIONS_SAVE_COMPLETED = "PAYMENT_CONFIGURATIONS/SAVE/COMPLETED";

export const SCHEMA_REQUEST = "SCHEMA/REQUEST";
export const SCOPE_BRAND_CLEAR = "SCOPE/BRAND/CLEAR";
export const SCOPE_BRAND_SET = "SCOPE/BRAND/SET";
export const SCOPE_BRAND_UPDATE = "SCOPE/BRAND/UPDATE";
export const SCOPE_COMPANY = progressTypes("SCOPE_COMPANY");
export const SCOPE_COMPANY_CLEAR = "SCOPE/COMPANY/CLEAR";
export const SCOPE_COMPANY_SET = "SCOPE/COMPANY/SET";
export const SCOPE_COMPANIES_REQUEST = "SCOPE/COMPANIES/REQUEST";
export const SCOPE_SHOW_TERMS = "SCOPE/SHOW/TERMS";
export const SCOPE_CURRENCY_SET = "SCOPE/CURRENCY/SET";
export const SCOPE_PAGE_SET = "SCOPE/PAGE/SET";
export const SCOPE_PAGE_CLEAR = "SCOPE/PAGE/CLEAR";
export const SCOPE_SITE_SET = "SCOPE/SITE/SET";
export const SCOPE_SITE_CLEAR = "SCOPE/SITE/CLEAR";
export const SCOPE_VIEW_AS = "SCOPE/VIEW_AS";
export const SCOPE_VIEW_AS_GUEST = "SCOPE/VIEW_AS_GUEST";
export const SCOPE_SYNC_FROM_CART = "SCOPE/SYNC_FROM_CART";
export const SCOPE_SET_USER_TYPE = "SCOPE/SET_USER_TYPE";
export const SCOPE_SYNC_TO_CART = "SCOPE/SYNC_TO_CART";
export const SCOPE_HIDE_MSRP = "SCOPE/HIDE_MSRP";
export const SCOPE_HIDE_WHOLESALE = "SCOPE/HIDE_WHOLESALE";
export const SCOPE_IS_CHILD_FRAME_SET = "SCOPE/IS_CHILD_FRAME/SET";
export const SNACKBARS_ADD = "SNACKBARS/ADD";
export const SNACKBARS_CLEAR = "SNACKBARS/CLEAR";
export const SNACKBARS_REMOVE = "SNACKBARS/REMOVE";
export const SUMMARY_DATA_FAILURE = "SUMMARY_DATA_FAILURE";
export const SUMMARY_DATA_REQUEST = "SUMMARY_DATA_REQUEST";
export const SUMMARY_DATA_SUCCESS = "SUMMARY_DATA_SUCCESST";
export const SUMMARY_EXPORT_FAILURE = "SUMMARY_EXPORT_FAILURE";
export const SUMMARY_EXPORT_REQUEST = "SUMMARY_EXPORT_REQUEST";
export const SUMMARY_EXPORT_SUCCESS = "SUMMARY_EXPORT_SUCCESST";
export const USER_LOGOUT = "USER/LOGOUT";
export const USER_PERMISSION_TYPES_FETCH = "USER_PERMISSION_TYPES/FETCH";
export const USER_PERMISSION_TYPES_FETCH_FAILURE = "USER_PERMISSION_TYPES/FAILURE";
export const USER_PERMISSION_TYPES_FETCH_COMPLETED = "USER_PERMISSION_TYPES/COMPLETED";

export const VIEW_FAILURE = "VIEW/FAILURE";
export const VIEW_REQUEST = "VIEW/REQUEST";
export const VIEW_SUCCESS = "VIEW/SUCCESS";
export const VIEW_RESET = "VIEW/RESET";
export const MUTATE_CLEAR = "MUTATE/CLEAR";
export const MUTATE_LIST_CREATE = "MUTATE/LIST/CREATE";
export const MUTATE_LIST_INSERT = "MUTATE/LIST/INSERT";
export const MUTATE_LIST_MOVE = "MUTATE/LIST/MOVE";
export const MUTATE_LIST_REMOVE = "MUTATE/LIST/REMOVE";
export const MUTATE_MAP_CREATE = "MUTATE/MAP/CREATE";
export const MUTATE_MAP_REMOVE = "MUTATE/MAP/REMOVE";
export const MUTATE_MAP_SET = "MUTATE/MAP/SET";
export const MUTATE_MIXED_CREATE = "MUTATE/MIXED/CREATE";
export const MUTATE_OPERATION = "MUTATE/OPERATION";
export const MUTATE_OPERATION_ENHANCED = "MUTATE/OPERATION/ENHANCED";
export const MUTATE_OPERATIONS_SENT = "MUTATE/OPERATIONS/SENT";
export const MUTATE_RETRY_SYNC = "MUTATE/SYNC/RETRY";
export const MUTATE_UNCOMMITTED_MUTATIONS_SET = "MUTATE/UNCOMMITTED_MUTATIONS/SET";
export const WHITEBOARD_BOARD_FETCH = "WHITEBOARD/BOARD/FETCH";
export const WHITEBOARD_BOARD_FETCH_COMPLETED = "WHITEBOARD/FETCH/COMPLETED";
export const WHITEBOARD_BOARDS_CREATE = "WHITEBOARD/BOARDS/CREATE";
export const WHITEBOARD_BOARDS_CREATE_COMPLETED = "WHITEBOARD/BOARDS/CREATE/COMPLETED";
export const WHITEBOARD_BOARDS_DUPLICATE = "WHITEBOARD/BOARDS/DUPLICATE";
export const WHITEBOARD_BOARDS_DELETE = "WHITEBOARD/BOARDS/DELETE";
export const WHITEBOARD_BOARDS_DELETE_COMPLETED = "WHITEBOARD/BOARDS/DELETE/COMPLETED";
export const WHITEBOARD_BOARDS_FETCH = "WHITEBOARD/BOARDS/FETCH";
export const WHITEBOARD_BOARDS_FETCH_COMPLETED = "WHITEBOARD/BOARDS/FETCH/COMPLETED";
export const WHITEBOARD_BOARDS_CLEAR = "WHITEBOARD/BOARDS/CLEAR";
export const WHITEBOARD_COMPONENT_ADD = "WHITEBOARD/COMPONENT/ADD";
export const WHITEBOARD_COMPONENT_DRAGGING_STATE = "WHITEBOARD/COMPONENT/DRAGGING_STATE";
export const WHITEBOARD_COMPONENT_RESIZE_STATE = "WHITEBOARD/COMPONENT/RESIZE_STATE";
export const WHITEBOARD_COMPONENT_SET_ID = "WHITEBOARD/ELEMENT/SET/ID";
export const WHITEBOARD_COMPONENTS_REFRESH = "WHITEBOARD/COMPONENTS/REFRESH";
export const WHITEBOARD_COMPONENTS_REFRESH_COMPLETED = "WHITEBOARD/COMPONENTS/REFRESH/COMPLETED";
export const WHITEBOARD_HISTORY_PUSH = "WHITEBOARD/HISTORY/PUSH";
export const WHITEBOARD_HISTORY_REDO = "WHITEBOARD/HISTORY/REDO";
export const WHITEBOARD_HISTORY_UNDO = "WHITEBOARD/HISTORY/UNDO";
export const WHITEBOARD_HISTORY_UPDATE = "WHITEBOARD/HISTORY/UPDATE";
export const WHITEBOARD_PAGES_CREATE = "WHITEBOARD/PAGES/CREATE";
export const WHITEBOARD_PAGE_CLEAR = "WHITEBOARD/PAGE/CLEAR";
export const WHITEBOARD_PAGE_REMOVE = "WHITEBOARD/PAGE/REMOVE";
export const WHITEBOARD_PAGE_MOVE = "WHITEBOARD/PAGE/MOVE";
export const WHITEBOARD_PAGE_FETCH = "WHITEBOARD/PAGE/FETCH";
export const WHITEBOARD_PAGE_FETCH_COMPLETED = "WHITEBOARD/PAGE/FETCH/COMPLETED";
export const WHITEBOARD_PAGE_SET = "WHITEBOARD/PAGE/SET";
export const WHITEBOARD_PAGE_SYNC = "WHITEBOARD/PAGE/SYNC";
export const WHITEBOARD_SYNC = "WHITEBOARD/SYNC";
export const WHITEBOARD_SCALE = "WHITEBOARD/SCALE";
export const WHITEBOARD_COMPONENT_ARRANGE = "WHITEBOARD/COMPONENT/ARRANGE";
export const WHITEBOARD_COMPONENT_REMOVE = "WHITEBOARD/COMPONENT/REMOVE";
export const WHITEBOARD_COMPONENT_REMOVE_COMPLETED = "WHITEBOARD/COMPONENT/REMOVE/COMPLETED";
export const WHITEBOARD_COMPONENT_MUTATE = "WHITEBOARD/COMPONENT/MUTATE";
export const WHITEBOARD_PERMISSIONS_FETCH = "WHITEBOARD/PERMISSIONS/FETCH";
export const WHITEBOARD_PERMISSIONS_FETCH_FAILURE = "WHITEBOARD/PERMISSIONS/FAILURE";
export const WHITEBOARD_PERMISSIONS_FETCH_COMPLETED = "WHITEBOARD/PERMISSIONS/COMPLETED";
export const WHITEBOARD_ADD_PERMISSION = "WHITEBOARD/PERMISSIONS/ADD";
export const WHITEBOARD_ADD_PERMISSION_COMPLETED = "WHITEBOARD/PERMISSIONS/ADD/COMPLETED";
export const WHITEBOARD_REMOVE_PERMISSION = "WHITEBOARD/PERMISSION/REMOVE";
export const WHITEBOARD_REMOVE_PERMISSION_COMPLETED = "WHITEBOARD/PERMISSION/REMOVE/COMPLETE";
export const WHITEBOARD_CHANGE_PERMISSION = "WHITEBOARD/PERMISSION/CHANGE";
export const WHITEBOARD_CHANGE_PERMISSION_COMPLETED = "WHITEBOARD/PERMISSION/CHANGE/COMPLETED";
export const WHITEBOARD_ADD_CONTACT = "WHITEBOARD/CONTACTS/ADD";
export const WHITEBOARD_REMOVE_CONTACT = "WHITEBOARD/CONTACTS/REMOVE";
export const WHITEBOARD_CONTACTS_RESET = "WHITEBOARD/CONTACTS/RESET";
export const WHITEBOARD_TOGGLE_GRID = "WHITEBOARD/GRID/TOGGLE";
export const WHITEBOARD_TOGGLE_SHARE_MODE = "WHITEBOARD/SHARE_MODE/TOGGLE";
export const WHITEBOARD_PRODUCTS_CART = "WHITEBOARD/PRODUCTS/CART";
export const WHITEBOARD_PRODUCTS_CLEAR = "WHITEBOARD/PRODUCTS/CLEAR";
export const WHITEBOARD_PRODUCTS_FETCH = "WHITEBOARD/PRODUCTS/FETCH";
export const WHITEBOARD_PRODUCTS_FETCH_COMPLETED = "WHITEBOARD/PRODUCTS/FETCH/COMPLETED";
export const WHITEBOARD_PRODUCTS_PANEL_CLEAR = "WHITEBOARD/PRODUCTS/PANEL/CLEAR";
export const WHITEBOARD_PRODUCTS_ORDER_FLOW_UPDATE = "WHITEBOARD/PRODUCTS/ORDER/FLOW/UPDATE";
export const WHITEBOARD_PRODUCTS_ORDER_FLOW_UPDATE_COMPLETED = "WHITEBOARD/PRODUCTS/ORDER/FLOW/UPDATE/COMPLETED";
export const WHITEBOARD_PROPERTY_CHANGE = "WHITEBOARD/PROPERTY/CHANGE";
export const WHITEBOARD_SEARCH_CHANGE = "WHITEBOARD/CONTACTS/SEARCH/CHANGE";
export const WHITEBOARD_PAGES_SYNC = "WHITEBOARD/PAGES/SYNC";
export const WHITEBOARD_HISTORY_CLEAR = "WHITEBOARD/HISTORY/CLEAR";
export const WHITEBOARD_TOGGLE_ENFORCE_ASPECT_RATIO = "WHITEBOARD/ASPECT_RATIO/TOGGLE";
export const WHITEBOARD_COMPONENT_COPY = "WHITEBOARD/COMPONENT/COPY";
export const WHITEBOARD_COMPONENT_PASTE = "WHITEBOARD/COMPONENT/PASTE";
export const WHITEBOARD_RESET = "WHITEBOARD/RESET";
export const WHITEBOARD_EXPORT_PDF_SUBMIT = "WHITEBOARD/EXPORT/PDF/SUBMIT";
export const WHITEBOARD_EXPORT_PDF_SUBMITTED = "WHITEBOARD/EXPORT/PDF/SUBMITTED";
export const WHITEBOARD_EXPORT_PDF_COMPLETED = "WHITEBOARD/EXPORT/PDF/COMPLETED";
export const WHITEBOARD_EXPORT_PDF_ACKNOWLEDGE = "WHITEBOARD/EXPORT/PDF/ACKNOWLEDGE";
export const WHITEBOARD_PRODUCT_IMAGE_CHANGE = "WHITEBOARD/PRODUCT/IMAGE/CHANGE";
export const WHITEBOARD_PRODUCT_IMAGE_CHANGE_COMPLETE = "WHITEBOARD/PRODUCT/IMAGE/CHANGE/COMPLETE";
export const WHITEBOARD_FILTER_BY_WORKING_ORDER = "WHITEBOARD/FILTER_BY_WORKING_ORDER";
export const WORKING_ORDER_EXPORT_TO_WHITEBOARD = "WORKING_ORDER/EXPORT_TO_WHITEBOARD";
export const WORKING_ORDER_LINK_WHITEBOARD = "WORKING_ORDER/LINK_WHITEBOARD";
export const WORKING_ORDER_SHOW_INVENTORY_ARRIVING = "WORKING_ORDER/SHOW_INVENTORY_ARRIVING";
export const WORKING_ORDER_HIDE_INVENTORY_ARRIVING = "WORKING_ORDER/HIDE_INVENTORY_ARRIVING";
export const WHITEBOARD_BULK_EXPORT_XLSX_PROCESSING = "WHITEBOARD/BULK/EXPORT/XLSX/PROCESSING";

export const CHANGE_RETAILER_PROFILE_DATA = "RETAILER_PROFILE/CHANGE";
export const RETAILER_BRAND_NAMES_SUGGESTIONS = "RETAILER_PROFILE/BRAND_NAMES";
export const RETAILER_PROFILE_SET_INITIAL = "RETAILER_PROFILE/SET_INITIAL";

export const MARKETPLACE = {
    CONNECT_ERROR: "marketplace/connect-error",
};

export const NOOP = "NOOP";

export const PRODUCTS = {
    FETCH: {
        START: "PRODUCTS/FETCH/START",
        COMPLETED: "PRODUCTS/FETCH/COMPLETED",
        RESET: "PRODUCTS/FETCH/RESET",
    },
    FETCH_BY_IDS: "PRODUCTS/FETCH_BY_IDS",
};

export const INSIGHTS = {
    CART_SIDE_PANEL_TOGGLE_OPEN: "INSIGHTS/CART_SIDE_PANEL/TOGGLE_OPEN",
    CART_SIDE_PANEL_TOGGLE: "INSIGHTS/CART_SIDE_PANEL/TOGGLE",
    GALLERY_SIDE_PANEL_TOGGLE: "INSIGHTS/GALLERY_SIDE_PANEL/TOGGLE",
    GALLERY_SIDE_PANEL_CLOSE: "INSIGHTS/GALLERY_SIDE_PANEL/CLOSE",
    UPDATE_CART: {
        START: "PRODUCTS/UPDATE_CART/START",
        COMPLETED: "PRODUCTS/UPDATE_CART/COMPLETED",
    },
    FETCH_BADGES: {
        START: "PRODUCTS/FETCH_BADGES/START",
        COMPLETED: "PRODUCTS/FETCH_BADGES/COMPLETED",
        ERROR: "PRODUCTS/FETCH_BADGES/ERROR",
    },
    FETCH_PRODUCT_STYLE_INSIGHTS: {
        START: "INSIGHTS/FETCH_PRODUCT_STYLE_INSIGHTS/START",
        COMPLETED: "INSIGHTS/FETCH_PRODUCT_STYLE_INSIGHTS/COMPLETED",
        ERROR: "INSIGHTS/FETCH_PRODUCT_STYLE_INSIGHTS/ERROR",
    },
    FETCH_CATEGORY_INSIGHTS: {
        START: "INSIGHTS/FETCH_CATEGORY_INSIGHTS/START",
        COMPLETED: "INSIGHTS/FETCH_CATEGORY_INSIGHTS/COMPLETED",
        ERROR: "INSIGHTS/FETCH_CATEGORY_INSIGHTS/ERROR",
    },
    FETCH_PRODUCT_COLOR_INSIGHTS: {
        START: "INSIGHTS/FETCH_PRODUCT_COLOR_INSIGHTS/START",
        COMPLETED: "INSIGHTS/FETCH_PRODUCT_COLOR_INSIGHTS/COMPLETED",
        ERROR: "INSIGHTS/FETCH_PRODUCT_COLOR_INSIGHTS/ERROR",
    },
    FETCH_PRODUCT_SIZE_INSIGHTS: {
        START: "INSIGHTS/FETCH_PRODUCT_SIZE_INSIGHTS/START",
        COMPLETED: "INSIGHTS/FETCH_PRODUCT_SIZE_INSIGHTS/COMPLETED",
        ERROR: "INSIGHTS/FETCH_PRODUCT_SIZE_INSIGHTS/ERROR",
        FETCH_DISABLED: "INSIGHTS/FETCH_PRODUCT_SIZE_INSIGHTS/FETCH_DISABLED",
    },
    CLEAR: "INSIGHTS/CLEAR",
};

export const PAGE_PRODUCTS = {
    FETCH: { START: "PAGE_PRODUCTS/FETCH/START" },
};

export const INTEGRATIONS = {
    MASTER_SCHEMA: {
        FETCH: {
            START: "NUORDER/INTEGRATIONS/MASTER_SCHEMA/FETCH/START",
            COMPLETED: "NUORDER/INTEGRATIONS/MASTER_SCHEMA/FETCH/COMPLETED",
        },
    },
    BRAND_SCHEMA_MAP: {
        FETCH: {
            START: "NUORDER/INTEGRATIONS/BRAND_SCHEMA_MAP/FETCH/START",
            COMPLETED: "NUORDER/INTEGRATIONS/BRAND_SCHEMA_MAP/FETCH/COMPLETED",
        },
        CREATE: {
            START: "NUORDER/INTEGRATIONS/BRAND_SCHEMA_MAP/CREATE/START",
            COMPLETED: "NUORDER/INTEGRATIONS/BRAND_SCHEMA_MAP/CREATE/COMPLETED",
        },
        UPDATE: {
            START: "NUORDER/INTEGRATIONS/BRAND_SCHEMA_MAP/UPDATE/START",
            COMPLETED: "NUORDER/INTEGRATIONS/BRAND_SCHEMA_MAP/UPDATE/COMPLETED",
        },
        RESET: "NUORDER/INTEGRATIONS/BRAND_SCHEMA_MAP/RESET",
    },
};

export const BRANDSETTINGS = {
    ORDERMINMAX: {
        FETCH: {
            START: "BRANDSETTINGS/ORDERMINMAX/FETCH/START",
            COMPLETED: "BRANDSETTINGS/ORDERMINMAX/FETCH/COMPLETED",
        },
        CREATE: {
            START: "BRANDSETTINGS/ORDERMINMAX/CREATE/START",
            COMPLETED: "BRANDSETTINGS/ORDERMINMAX/CREATE/COMPLETED",
        },
        UPDATE: {
            START: "BRANDSETTINGS/ORDERMINMAX/UPDATE/START",
            COMPLETED: "BRANDSETTINGS/ORDERMINMAX/UPDATE/COMPLETED",
        },
        DELETE: {
            START: "BRANDSETTINGS/ORDERMINMAX/DELETE/START",
            COMPLETED: "BRANDSETTINGS/ORDERMINMAX/DELETE/COMPLETED",
        },
    },

    INFO: {
        UPDATE: {
            START: "BRANDSETTINGS/INFO/UPDATE/START",
            COMPLETED: "BRANDSETTINGS/INFO/UPDATE/COMPLETED",
        },
    },
    PREFERREDRETAILERS: {
        FETCH: {
            START: "BRANDSETTINGS/PREFERREDRETAILERS/FETCH/START",
            COMPLETED: "BRANDSETTINGS/PREFERREDRETAILERS/FETCH/COMPLETED",
        },
        UPDATE: {
            START: "BRANDSETTINGS/PREFERREDRETAILERS/UPDATE/START",
            COMPLETED: "BRANDSETTINGS/PREFERREDRETAILERS/UPDATE/COMPLETED",
        },
    },
    IMAGE_FORMATS: {
        UPDATE: progressTypes("BRANDSETTINGS/IMAGE_FORMATS", "UPDATE"),
    },
};

export const IMPERSONATION = {
    REQUEST_IMPERSONATION: {
        FETCH: {
            START: "IMPERSONATION/REQUEST_IMPERSONATION/FETCH/START",
            COMPLETED: "IMPERSONATION/REQUEST_IMPERSONATION/FETCH/COMPLETED",
        },
    },
    ENTER_IMPERSONATION: {
        CREATE: {
            START: "IMPERSONATION/ENTER_IMPERSONATION/CREATE/START",
            COMPLETED: "IMPERSONATION/ENTER_IMPERSONATION/CREATE/COMPLETED",
        },
        RESET: "IMPERSONATION/ENTER_IMPERSONATION/RESET",
    },
    STOP_IMPERSONATION: {
        FETCH: {
            START: "IMPERSONATION/STOP_IMPERSONATION/FETCH/START",
            COMPLETED: "IMPERSONATION/STOP_IMPERSONATION/FETCH/COMPLETED",
        },
    },
};

export const PRODUCT = {
    FETCH: {
        INIT: "PRODUCT/FETCH/INIT",
        START: "PRODUCT/FETCH/START",
        COMPLETED: "PRODUCT/FETCH/COMPLETED",
    },
    VARIANTS: {
        FETCH: {
            START: "PRODUCT/VARIANTS/FETCH/START",
            COMPLETED: "PRODUCT/VARIANTS/FETCH/COMPLETED",
        },
    },
    WAREHOUSES: {
        FETCH: {
            START: "PRODUCT/WAREHOUSES/FETCH/START",
            COMPLETED: "PRODUCT/WAREHOUSES/FETCH/COMPLETED",
        },
    },
    WAREHOUSE: {
        INVENTORY: {
            FETCH: {
                START: "PRODUCT/WAREHOUSE/INVENTORY/FETCH/START",
                COMPLETED: "PRODUCT/WAREHOUSE/INVENTORY/FETCH/COMPLETED",
            },
        },
        AVAILABILITY: {
            FETCH: {
                START: "PRODUCT/WAREHOUSE/AVAILABILITY/FETCH/START",
                COMPLETED: "PRODUCT/WAREHOUSE/AVAILABILITY/FETCH/COMPLETED",
            },
        },
        REPLENISHMENTS: {
            FETCH: {
                START: "PRODUCT/WAREHOUSE/REPLENISHMENTS/FETCH/START",
                COMPLETED: "PRODUCT/WAREHOUSE/REPLENISHMENTS/FETCH/COMPLETED",
            },
        },
    },
};

export const SCHEMA = {
    DUMMY: {
        CREATE: "SCHEMA/PLACEHOLDER/CREATE",
    },
};

export const CATALOG = {
    ENTRIES: {
        ALL: {
            FETCH: {
                START: "CATALOG/ENTRIES-ALL/FETCH/START",
                COMPLETED: "CATALOG/ENTRIES-ALL/FETCH/COMPLETED",
                CANCEL: "CATALOG/ENTRIES-ALL/FETCH/CANCEL",
            },
            REMOVE: "CATALOG/ENTRIES-ALL/REMOVE",
            ADD: "CATALOG/ENTRIES-ALL/ADD",
        },
        FETCH: {
            START: "CATALOG/ENTRIES/FETCH/START",
            COMPLETED: "CATALOG/ENTRIES/FETCH/COMPLETED",
            CANCEL: "CATALOG/ENTRIES/FETCH/CANCEL",
        },
        REORDER: {
            START: "CATALOG/ENTRIES/REORDER/START",
            COMPLETED: "CATALOG/ENTRIES/REORDER/COMPLETED",
        },
        DELETE: {
            START: "CATALOG/ENTRIES/DELETE/START",
            COMPLETED: "CATALOG/ENTRIES/DELETE/COMPLETED",
            PRUNE: "CATALOG/ENTRIES/DELETE/PRUNE",
        },
        CACHE: {
            INVALIDATE: "CATALOG/ENTRIES/CACHE/INVALIDATE",
        },
        FILTERS: {
            REFRESH: {
                START: "CATALOG/ENTRIES/FILTERS/REFRESH/START",
                COMPLETE: "CATALOG/ENTRIES/FILTERS/REFRESH/COMPLETE",
            },
        },
    },
    ENTRY: {
        ADD: {
            FETCH: {
                START: "CATALOG/ENTRY/ADD/FETCH/START",
                COMPLETED: "CATALOG/ENTRY/ADD/FETCH/COMPLETED",
            },
        },
        DELETE: {
            START: "CATALOG/ENTRY/DELETE/START",
            COMPLETED: "CATALOG/ENTRY/DELETE/COMPLETED",
        },
    },
    IMPORT: {
        ...progressTypes("CATALOG", "IMPORT"),
        RESET_STATE: "CATALOG/IMPORT/RESET_STATE",
    },
    SET_PROCESSING: "CATALOG/SET_PROCESSING",
};

export const CATALOGS = {
    FETCH: {
        START: "CATALOGS/FETCH/START",
        COMPLETED: "CATALOGS/FETCH/COMPLETED",
        CANCEL: "CATALOGS/FETCH/CANCEL",
    },
};

export const MERCHANT = {
    SCHEMA: {
        FETCH: "MERCHANT/SCHEMA/FETCH",
        FETCHED: "MERCHANT/SCHEMA/FETCHED",
        MUTATE: "MERCHANT/SCHEMA/MUTATE",
        MUTATED: "MERCHANT/SCHEMA/MUTATED",
    },
    SETUP_STEPS: {
        GET: {
            REQUEST: "MERCHANT/SETUP_STEPS/GET/REQUEST",
            COMPLETE: "MERCHANT/SETUP_STEPS/GET/COMPLETE",
        },
        PUT: {
            REQUEST: "MERCHANT/SETUP_STEPS/PUT/REQUEST",
            COMPLETE: "MERCHANT/SETUP_STEPS/PUT/COMPLETE",
        },
    },
    PREFERENCE: {
        GET: {
            REQUEST: "MERCHANT/PREFERENCE/GET/REQUEST",
            COMPLETE: "MERCHANT/PREFERENCE/GET/COMPLETE",
        },
        UPDATE: {
            REQUEST: "MERCHANT/PREFERENCE/UPDATE/REQUEST",
            COMPLETE: "MERCHANT/PREFERENCE/UPDATE/COMPLETE",
        },
    },
    DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE: {
        GET: {
            REQUEST: "MERCHANT/DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE/GET/REQUEST",
            COMPLETE: "MERCHANT/DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE/GET/COMPLETE",
        },
        UPDATE: {
            COMPLETE: "MERCHANT/DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE/UPDATE/COMPLETE",
        },
    },
    FEATURE_PREFERENCE: {
        GET: {
            REQUEST: "MERCHANT/FEATURE_PREFERENCE/GET/REQUEST",
            COMPLETE: "MERCHANT/FEATURE_PREFERENCE/GET/COMPLETE",
        },
        CREATE: {
            REQUEST: "MERCHANT/FEATURE_PREFERENCE/CREATE/REQUEST",
            COMPLETE: "MERCHANT/FEATURE_PREFERENCE/CREATE/COMPLETE",
        },
        UPDATE: {
            COMPLETE: "MERCHANT/FEATURE_PREFERENCE/UPDATE/COMPLETE",
        },
    },
    DEFAULT_ITEM: {
        UPDATE: {
            COMPLETE: "MERCHANT/DEFAULT_ITEM/UPDATE/COMPLETE",
        },
    },
    PURCHASE_ORDER_DOOR_GROUP: {
        LIST: {
            REQUEST: "MERCHANT/PURCHASE_ORDER_DOOR_GROUP/LIST/REQUEST",
            COMPLETE: "MERCHANT/PURCHASE_ORDER_DOOR_GROUP/LIST/COMPLETE",
        },
        REMOVE: {
            REQUEST: "MERCHANT/PURCHASE_ORDER_DOOR_GROUP/REMOVE/REQUEST",
            COMPLETE: "MERCHANT/PURCHASE_ORDER_DOOR_GROUP/REMOVE/COMPLETE",
        },
    },
    PURCHASE_ORDER: {
        LIST: {
            REQUEST: "MERCHANT/PURCHASE_ORDER/LIST/REQUEST",
            COMPLETE: "MERCHANT/PURCHASE_ORDER/LIST/COMPLETE",
        },
        CREATE: {
            REQUEST: "MERCHANT/PURCHASE_ORDER/CREATE/REQUEST",
            COMPLETE: "MERCHANT/PURCHASE_ORDER/CREATE/COMPLETE",
        },
        UPDATE: {
            REQUEST: "MERCHANT/PURCHASE_ORDER/UPDATE/REQUEST",
            COMPLETE: "MERCHANT/PURCHASE_ORDER/UPDATE/COMPLETE",
        },
        REMOVE: {
            REQUEST: "MERCHANT/PURCHASE_ORDER/REMOVE/REQUEST",
            COMPLETE: "MERCHANT/PURCHASE_ORDER/REMOVE/COMPLETE",
        },
        SORT: {
            REQUEST: "MERCHANT/PURCHASE_ORDER/SORT/REQUEST",
            COMPLETE: "MERCHANT/PURCHASE_ORDER/SORT/COMPLETE",
        },
    },
    COLLECTION_VERSION_STATUS: {
        LIST: {
            REQUEST: "MERCHANT/COLLECTION_VERSION_STATUS/LIST/REQUEST",
            COMPLETE: "MERCHANT/COLLECTION_VERSION_STATUS/LIST/COMPLETE",
        },
        REMOVE: {
            REQUEST: "MERCHANT/COLLECTION_VERSION_STATUS/REMOVE/REQUEST",
            COMPLETE: "MERCHANT/COLLECTION_VERSION_STATUS/REMOVE/COMPLETE",
        },
    },
    AUTO_OPEN_MARKET_SETTINGS: "MERCHANT/AUTO_OPEN_MARKET_SETTINGS",
    SHARED_SETTINGS: {
        GET: {
            REQUEST: "MERCHANT/SHARED_SETTINGS/GET/REQUEST",
            COMPLETE: "MERCHANT/SHARED_SETTINGS/GET/COMPLETE",
        },
        UPDATE: {
            REQUEST: "MERCHANT/SHARED_SETTINGS/UPDATE/REQUEST",
            COMPLETE: "MERCHANT/SHARED_SETTINGS/UPDATE/COMPLETE",
        },
    },
};

export const ALLOCATION_DIMENSION = {
    LIST: {
        REQUEST: "ALLOCATION_DIMENSION/LIST/REQUEST",
        COMPLETE: "ALLOCATION_DIMENSION/LIST/COMPLETE",
    },
    CREATE: {
        COMPLETE: "ALLOCATION_DIMENSION/CREATE/COMPLETE",
    },
    CREATE_DEFAULT: {
        REQUEST: "ALLOCATION_DIMENSION/CREATE_DEFAULT/REQUEST",
        COMPLETE: "ALLOCATION_DIMENSION/CREATE_DEFAULT/COMPLETE",
    },
    UPDATE: {
        COMPLETE: "ALLOCATION_DIMENSION/UPDATE/COMPLETE",
    },
    GET: {
        COMPLETE: "ALLOCATION_DIMENSION/GET/COMPLETE",
    },
    VALUES: {
        LIST: {
            REQUEST: "ALLOCATION_DIMENSION/VALUES/LIST/REQUEST",
            COMPLETE: "ALLOCATION_DIMENSION/VALUES/LIST/COMPLETE",
        },
        CREATE: {
            COMPLETE: "ALLOCATION_DIMENSION/VALUES/CREATE/COMPLETE",
        },
        UPDATE: {
            COMPLETE: "ALLOCATION_DIMENSION/VALUES/UPDATE/COMPLETE",
        },
        SORT: {
            COMPLETE: "ALLOCATION_DIMENSION/VALUES/SORT/COMPLETE",
        },
    },
};

export const COLLECTIONS = {
    CLEAR: "COLLECTIONS/CLEAR",
    COLLECTION: {
        REFRESH_PAGE: "COLLECTION/REFRESH_PAGE",
        HEARTBEAT: "COLLECTION/HEARTBEAT",
        SYNC: {
            START: "COLLECTION/SYNC/START",
            COMPLETED: "COLLECTION/SYNC/COMPLETED",
            CONFLICT: "COLLECTION/SYNC/CONFLICT",
            ERROR: "COLLECTION/SYNC/ERROR",
        },
        CLEAR: "COLLECTION/CLEAR",
        CREATE: {
            START: "COLLECTION/CREATE/START",
            COMPLETED: "COLLECTION/CREATE/COMPLETED",
        },
        COPY: {
            START: "COLLECTION/COPY/START",
            COMPLETED: "COLLECTION/COPY/COMPLETED",
        },
        DRIVE_ITEM: {
            FETCH: {
                START: "COLLECTION/DRIVE_ITEM/FETCH/START",
                COMPLETED: "COLLECTION/DRIVE_ITEM/FETCH/COMPLETED",
            },
            RENAME: {
                COMPLETED: "COLLECTION/DRIVE_ITEM/RENAME/COMPLETED",
            },
            CREATE_ROLLUP_SNAPSHOT: {
                INIT: "COLLECTION/DRIVE_ITEM/CREATE_ROLLUP_SNAPSHOT/INIT",
                START: "COLLECTION/DRIVE_ITEM/CREATE_ROLLUP_SNAPSHOT/START",
                COMPLETED: "COLLECTION/DRIVE_ITEM/CREATE_ROLLUP_SNAPSHOT/COMPLETED",
            },
        },
        UPDATE_COLLECTION_SETTINGS: {
            OPEN_CLOSE: "COLLECTION/UPDATE_COLLECTION_SETTINGS/OPEN_CLOSE",
            START: "COLLECTION/UPDATE_COLLECTION_SETTINGS/START",
            COMPLETED: "COLLECTION/UPDATE_COLLECTION_SETTINGS/COMPLETED",
        },
        ROLLUP_SNAPSHOT_ITEM: {
            FETCH: {
                START: "COLLECTION/ROLLUP_SNAPSHOT_ITEM/FETCH/START",
                COMPLETED: "COLLECTION/ROLLUP_SNAPSHOT_ITEM/FETCH/COMPLETED",
            },
            SET_ITEM: "COLLECTION/ROLLUP_SNAPSHOT_ITEM/SET_ITEM",
        },
        ROLLUP_OBJECT: {
            FETCH: {
                START: "COLLECTION/ROLLUP_OBJECT/FETCH/START",
                COMPLETED: "COLLECTION/ROLLUP_OBJECT/FETCH/COMPLETED",
            },
            OBJECT_STREAM: {
                STREAM: "COLLECTION/ROLLUP_OBJECT/OBJECT_STREAM/STREAM",
            },
        },
        FETCH: {
            START: "COLLECTION/FETCH/START",
            INTEGRATE: "COLLECTION/FETCH/INTEGRATE",
            COMPLETED: "COLLECTION/FETCH/COMPLETED",
        },
        DELETE: {
            START: "COLLECTION/DELETE/START",
            COMPLETED: "COLLECTION/DELETE/COMPLETED",
        },
        UPDATE: {
            // eg top level fields like name
            START: "COLLECTION/UPDATE/START",
            COMPLETED: "COLLECTION/UPDATE/COMPLETED",
        },
        UPDATES: {
            RECEIVED: "COLLECTION/UPDATES/RECEIVED",
        },
        PROPS: {
            SYNC: {
                START: "COLLECTION/PROPS/SYNC/START",
                COMPLETED: "COLLECTION/PROPS/SYNC/COMPLETED",
            },
            COMPARE: "COLLECTION/PROPS/COMPARE",
        },
        SESSION: {
            CREATE: {
                START: "COLLECTION/SESSION/CREATE/START",
                COMPLETED: "COLLECTION/SESSION/CREATE/COMPLETED",
            },
            CLEAR: "COLLECTION/SESSION/CLEAR",
            FOCUS: {
                SET: "COLLECTION/SESSION/FOCUS/SET",
            },
            UPDATES: {
                SUBSCRIBE: "COLLECTION/SESSION/UPDATES/SUBSCRIBE",
                UNSUBSCRIBE: "COLLECTION/SESSION/UPDATES/UNSUBSCRIBE",
                POLL: "COLLECTION/SESSION/UPDATES/POLL",
                RECEIVED: "COLLECTION/SESSION/UPDATES/RECEIVED",
            },
        },
        ITEM_DISPLAY_PREFERENCES: {
            MUTATE: "COLLECTION/ITEM_DISPLAY_PREFERENCES/MUTATE",
        },
        ITEM_DISPLAY_PROPERTY: {
            OVERRIDE_DISPLAY_NAME: {
                MUTATE: "COLLECTION/ITEM_DISPLAY_PROPERTY/OVERRIDE_DISPLAY_NAME/MUTATE",
            },
            INIT_DEPENDENTS_FIELDS_LOOKUP_MAP: "COLLECTION/ITEM_DISPLAY_PROPERTY/INIT_DEPENDENTS_FIELDS_LOOKUP_MAP",
        },
        ITEMS: {
            SYNC: {
                START: "COLLECTION/ITEMS/SYNC/START",
                COMPLETED: "COLLECTION/ITEMS/SYNC/COMPLETED",
                CONFLICT: "COLLECTION/ITEMS/SYNC/CONFLICT",
                ERROR: "COLLECTION/ITEMS/SYNC/ERROR",
            },
            REMOVE: "COLLECTION/ITEMS/REMOVE", // bulk actions
            DEFAULT_ITEM: {
                MUTATE: "COLLECTION/ITEMS/DEFAULT_ITEM/MUTATE",
                SYNC: {
                    START: "COLLECTION/ITEMS/DEFAULT_ITEM/SYNC/START",
                    COMPLETE: "COLLECTION/ITEMS/DEFAULT_ITEM/SYNC/COMPLETE",
                },
            },
            ITEM: {
                CREATE: "COLLECTION/ITEMS/ITEM/CREATE",
                MUTATE: "COLLECTION/ITEMS/ITEM/MUTATE",
                MOVE: "COLLECTION/ITEMS/ITEM/MOVE",
                REMOVE: "COLLECTION/ITEMS/ITEM/REMOVE",
                SYNC_AUTO_SELECT_SINGLE_RESULT: "COLLECTION/ITEMS/ITEM/SYNC_AUTO_SELECT_SINGLE_RESULT",
            },
            BULK: {
                START: "COLLECTION/ITEMS/BULK/START",
                COMPLETED: "COLLECTION/ITEMS/BULK/COMPLETED",
                MISSING_PRODUCTS: {
                    VIEWED: "COLLECTION/ITEMS/BULK/MISSING_PRODUCTS/VIEWED",
                },
            },
            SCROLL_TO: "COLLECTION/ITEMS/SCROLL_TO",
            UPDATES: {
                SUBSCRIBE: "COLLECTION/ITEMS/UPDATES/SUBSCRIBE",
                UNSUBSCRIBE: "COLLECTION/ITEMS/UPDATES/UNSUBSCRIBE",
                POLL: "COLLECTION/ITEMS/UPDATES/POLL",
            },
            PRODUCTS: {
                UPDATES: {
                    CHECK: {
                        START: "COLLECTION/ITEMS/PRODUCT/UPDATES/CHECK/START",
                        STOP: "COLLECTION/ITEMS/PRODUCT/UPDATES/CHECK/STOP",
                    },
                    CLEAR: "COLLECTION/ITEMS/PRODUCT/UPDATES/CLEAR",
                },
                SYNC: {
                    START: "COLLECTION/ITEMS/PRODUCT/SYNC/START",
                    STOP: "COLLECTION/ITEMS/PRODUCT/SYNC/STOP",
                },
            },
            ITEMDISPLAYPREFERENCES: {
                UPDATES: {
                    POLL: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/UPDATES/POLL",
                    UNSUBSCRIBE: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/UPDATES/UNSUBSCRIBE",
                },
                DEFAULT_VIEW: {
                    RESET: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/DEFAULT_VIEW/RESET",
                },
                CURRENT_VIEW: {
                    INIT: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/CURRENT_VIEW/INIT",
                    CHANGE: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/CURRENT_VIEW/CHANGE",
                    RESET: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/CURRENT_VIEW/RESET",
                },
                FETCH: {
                    START: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/FETCH/START",
                    COMPLETED: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/FETCH/COMPLETED",
                },
                SYNC: {
                    START: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/SYNC/START",
                    COMPLETED: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/SYNC/COMPLETED",
                },
                MERCHANT_ITEM_DISPLAY_PREFERENCE: {
                    FETCH: {
                        START: "COLLECTION/ITEMS/MERCHANT_DISPLAY_PREFERENCES/FETCH/START",
                        COMPLETED: "COLLECTION/ITEMS/MERCHANT_DISPLAY_PREFERENCES/FETCH/COMPLETED",
                    },
                },
                IITEMDISPLAYPREFERENCE: {
                    ADD: {
                        START: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/ADD/START",
                        COMPLETED: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/ADD/COMPLETED",
                    },
                    REMOVE: {
                        START: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/REMOVE/START",
                        COMPLETED: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/REMOVE/COMPLETED",
                    },
                    MERCHANT_EDIT: {
                        START: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/MERCHANT_EDIT/START",
                        COMPLETED:
                            "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/MERCHANT_EDIT/COMPLETED",
                    },
                    MERCHANT_DELETE: {
                        START: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/MERCHANT_DELETE/START",
                        COMPLETED:
                            "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/MERCHANT_DELETE/COMPLETED",
                    },
                    MERCHANT_LOCAL_EDIT: {
                        START: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/MERCHANT_LOCAL_EDIT/START",
                        COMPLETED:
                            "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/MERCHANT_LOCAL_EDIT/COMPLETED",
                    },
                    EDIT: {
                        START: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/EDIT/START",
                        COMPLETED: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/EDIT/COMPLETED",
                    },
                    PROMOTE: {
                        START: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/PROMOTE/START",
                        COMPLETED: "COLLECTION/ITEMS/ITEMDISPLAYPREFERENCES/ITEMDISPLAYPREFERENCE/PROMOTE/COMPLETED",
                    },
                },
            },
            REVIEW_TAB: {
                SYNC: {
                    START: "COLLECTION/ITEMS/REVIEWDISPLAYPREFERENCES/SYNC/START",
                    COMPLETED: "COLLECTION/ITEMS/REVIEWDISPLAYPREFERENCES/SYNC/COMPLETED",
                },
                REVIEWDISPLAYPREFERENCES: {
                    ADD: {
                        START: "COLLECTION/ITEMS/REVIEWDISPLAYPREFERENCES/REVIEWDISPLAYPREFERENCE/ADD/START",
                        COMPLETED: "COLLECTION/ITEMS/REVIEWDISPLAYPREFERENCES/REVIEWDISPLAYPREFERENCE/ADD/COMPLETED",
                    },
                    REMOVE: {
                        START: "COLLECTION/ITEMS/REVIEWDISPLAYPREFERENCES/REVIEWDISPLAYPREFERENCE/REMOVE/START",
                        COMPLETED: "COLLECTION/ITEMS/REVIEWDISPLAYPREFERENCES/REVIEWDISPLAYPREFERENCE/REMOVE/COMPLETED",
                    },
                    EDIT: {
                        START: "COLLECTION/ITEMS/REVIEWDISPLAYPREFERENCES/REVIEWDISPLAYPREFERENCE/EDIT/START",
                        COMPLETED: "COLLECTION/ITEMS/REVIEWDISPLAYPREFERENCES/REVIEWDISPLAYPREFERENCE/EDIT/COMPLETED",
                    },
                },
            },
        },
        ALLOCATION_DIMENSION: {
            BAG_VALUE: {
                MUTATE: "COLLECTION/ALLOCATION_DIMENSION/BAG_VALUE/MUTATE",
                BULK_MUTATE: "COLLECTION/ALLOCATION_DIMENSION/BAG_VALUE/BULK_MUTATE",
                CLEAR: "COLLECTION/ALLOCATION_DIMENSION/BAG_VALUE/CLEAR",
                BULK_CLEAR: "COLLECTION/ALLOCATION_DIMENSION/BAG_VALUE/BULK_CLEAR",
                REPLACE_BAG_VALUES: "COLLECTION/ALLOCATION_DIMENSION/BAG_VALUE/REPLACE_BAG_VALUES",
                SYNC: {
                    START: "COLLECTION/ALLOCATION_DIMENSION/BAG_VALUE/SYNC/START",
                    COMPLETE: "COLLECTION/ALLOCATION_DIMENSION/BAG_VALUE/SYNC/COMPLETE",
                    CONFLICT: "COLLECTION/ALLOCATION_DIMENSION/BAG_VALUE/SYNC/CONFLICT",
                    ERROR: "COLLECTION/ALLOCATION_DIMENSION/BAG_VALUE/SYNC/ERROR",
                },
            },
            VALUE: {
                CHANGES_QUEUE: {
                    QUEUE: "COLLECTION/ALLOCATION_DIMENSION/VALUE/CHANGES_QUEUE/QUEUE",
                    START: "COLLECTION/ALLOCATION_DIMENSION/VALUE/CHANGES_QUEUE/START",
                    COMPLETED: "COLLECTION/ALLOCATION_DIMENSION/VALUE/CHANGES_QUEUE/COMPLETED",
                },
                SYNC: {
                    START: "COLLECTION/ALLOCATION_DIMENSION/VALUE/SYNC/START",
                    COMPLETED: "COLLECTION/ALLOCATION_DIMENSION/VALUE/SYNC/COMPLETED",
                },
                BULK_MUTATE: {
                    START: "COLLECTION/ALLOCATION_DIMENSION/VALUE/BULK_MUTATE/START",
                    COMPLETED: "COLLECTION/ALLOCATION_DIMENSION/VALUE/BULK_MUTATE/COMPLETED",
                },
                MOVE: {
                    START: "COLLECTION/ALLOCATION_DIMENSION/VALUE/MOVE/START",
                    COMPLETED: "COLLECTION/ALLOCATION_DIMENSION/VALUE/MOVE/COMPLETED",
                },
            },
            ATTRIBUTES: {
                UPDATE: {
                    REQUEST: "COLLECTION/ALLOCATION_DIMENSION/ATTRIBUTES/UPDATE/REQUEST",
                    COMPLETE: "COLLECTION/ALLOCATION_DIMENSION/ATTRIBUTES/UPDATE/COMPLETE",
                },
                ADD_UPDATE: {
                    REQUEST: "COLLECTION/ALLOCATION_DIMENSION/ATTRIBUTES/ADDUPDATE/REQUEST",
                },
            },
            SYNC: {
                START: "COLLECTION/ALLOCATION_DIMENSION/SYNC/START",
                COMPLETED: "COLLECTION/ALLOCATION_DIMENSION/SYNC/COMPLETED",
            },
        },
        DELIVERY_PURCHASE_ORDER: {
            RECONCILE: {
                START: "COLLECTION/DELIVERY_PURCHASE_ORDER/RECONCILE/START",
                COMPLETED: "COLLECTION/DELIVERY_PURCHASE_ORDER/RECONCILE/COMPLETED",
            },
            MUTATE: {
                START: "COLLECTION/DELIVERY_PURCHASE_ORDER/MUTATE/START",
                COMPLETE: "COLLECTION/DELIVERY_PURCHASE_ORDER/MUTATE/COMPLETE",
            },
            SORT: {
                START: "COLLECTION/DELIVERY_PURCHASE_ORDER/SORT/START",
                COMPLETE: "COLLECTION/DELIVERY_PURCHASE_ORDER/SORT/COMPLETE",
            },
            SYNC: {
                START: "COLLECTION/DELIVERY_PURCHASE_ORDER/SYNC/START",
                COMPLETE: "COLLECTION/DELIVERY_PURCHASE_ORDER/SYNC/COMPLETE",
            },
        },
        REVIEW_PLANS: {
            UPDATES: {
                POLL: "COLLECTION/REVIEW_PLANS/UPDATES/POLL",
                UNSUBSCRIBE: "COLLECTION/REVIEW_PLANS/UPDATES/UNSUBSCRIBE",
            },
            SYNC: {
                START: "COLLECTION/REVIEW_PLANS/SYNC/START",
                COMPLETED: "COLLECTION/REVIEW_PLANS/SYNC/COMPLETED",
            },
            MUTATE: "COLLECTION/REVIEW_PLANS/MUTATE",
            ROWS: {
                LOAD: "COLLECTION/REVIEW_PLANS/ROWS/LOAD",
                UPDATE: "COLLECTION/REVIEW_PLANS/ROWS/UPDATE",
                RELOAD: "COLLECTION/REVIEW_PLANS/ROWS/RELOAD",
            },
            LOAD: "COLLECTION/REVIEW_PLANS/LOAD",
        },
        POIS: {
            FETCH: {
                START: "COLLECTION/POIS/FETCH/START",
                STOP: "COLLECTION/POIS/FETCH/STOP",
            },
        },
        DEBUGGER_REVISION: {
            FETCH: {
                START: "COLLECTION/DEBUGGER_REVISION/FETCH/START",
                STOP: "COLLECTION/DEBUGGER_REVISION/FETCH/STOP",
            },
        },
        DEBUGGER_SNAPSHOT: {
            COMPLETED: "COLLECTION/DEBUGGER_SNAPSHOT/COMPLETED",
        },
        POI: {
            FETCH: "COLLECTION/POI/FETCH",
            TAG: {
                SET: {
                    START: "COLLECTION/POI/TAG/SET/START",
                    COMPLETE: "COLLECTION/POI/TAG/SET/COMPLETE",
                },
                REMOVE: {
                    START: "COLLECTION/POI/TAG/REMOVE/START",
                    COMPLETE: "COLLECTION/POI/TAG/REMOVE/COMPLETE",
                },
                SYNC: {
                    START: "COLLECTION/POI/TAG/SYNC/START",
                    COMPLETE: "COLLECTION/POI/TAG/SYNC/COMPLETE",
                },
            },
        },
        OBJECT: {
            FETCH: "COLLECTION/OBJECT/FETCH",
            SYNC: {
                START: "COLLECTION/OBJECT/SYNC/START",
                RETRY: "COLLECTION/OBJECT/SYNC/RETRY",
            },
        },
        HASHTAGS: {
            ADD: "COLLECTION/HASHTAGS/ADD",
        },
        GRID: {
            REGISTER: "COLLECTION/GRID/REGISTER",
            UNREGISTER: "COLLECTION/GRID/UNREGISTER",
            XLS_EXPORT: "COLLECTION/GRID/XLS_EXPORT",
            SET_IMAGE_CELL_DIMENSIONS: "COLLECTION/GRID/SET_IMAGE_CELL_DIMENSIONS",
        },
        PERMISSIONS: {
            FETCH: {
                START: "COLLECTION/PERMISSIONS/FETCH/START",
                COMPLETED: "COLLECTION/PERMISSIONS/FETCH/COMPLETED",
            },
            CONTACTS: {
                SET: "COLLECTION/CONTACTS/SET",
                SEARCH: "COLLECTION/CONTACTS/SEARCH",
                FETCH: {
                    START: "COLLECTION/CONTACTS/FETCH/START",
                    COMPLETED: "COLLECTION/CONTACTS/FETCH/COMPLETED",
                },
            },
            CREATE: {
                START: "COLLECTION/PERMISSION/CREATE/START",
                COMPLETED: "COLLECTION/PERMISSION/CREATE/COMPLETED",
            },
            UPDATE: {
                START: "COLLECTION/PERMISSION/UPDATE/START",
                COMPLETED: "COLLECTION/PERMISSION/UPDATE/COMPLETED",
            },
            DELETE: {
                START: "COLLECTION/PERMISSION/DELETE/START",
                COMPLETED: "COLLECTION/PERMISSION/DELETE/COMPLETED",
            },
        },
        EXPORT: {
            CREATE: {
                START: "COLLECTION/EXPORT/START",
                COMPLETED: "COLLECTION/EXPORT/COMPLETED",
            },
            POLL: "COLLECTION/EXPORT/POLL",
            RECEIVED: "COLLECTION/EXPORT/RECEIVED",
            CLEAR: "COLLECTION/EXPORT/CLEAR",
            LOGS: {
                FETCH: {
                    START: "COLLECTION/EXPORT/LOG/FETCH/START",
                    COMPLETED: "COLLECTION/EXPORT/LOG/FETCH/COMPLETED",
                },
                CLEAR: "COLLECTION/EXPORT/LOG/CLEAR",
            },
        },
        EXPORT_ITEMS: {
            START: "COLLECTION/EXPORT_ITEMS/START",
            COMPLETED: "COLLECTION/EXPORT_ITEMS/COMPLETED",
        },
        NORDSTROM: {
            CREATE: {
                START: "COLLECTION/NORDSTROM-PUSH/START",
                COMPLETED: "COLLECTION/NORDSTROM-PUSH/COMPLETED",
            },
        },
        HISTORY: {
            PUSH: "COLLECTION/HISTORY/PUSH",
            UNDO: "COLLECTION/HISTORY/UNDO",
            REDO: "COLLECTION/HISTORY/REDO",
            UPDATE: "COLLECTION/HISTORY/UPDATE",
            CLEAR: "COLLECTION/HISTORY/CLEAR",
        },
        PRODUCT: {
            FETCH: {
                START: "COLLECTION/PRODUCT/FETCH/START",
                COMPLETED: "COLLECTION/PRODUCT/FETCH/COMPLETED",
            },
            VARIANTS: {
                FETCH: {
                    START: "COLLECTION/PRODUCT/VARIANTS/FETCH/START",
                    COMPLETED: "COLLECTION/PRODUCT/VARIANTS/FETCH/COMPLETED",
                },
            },
            INVENTORY: {
                SYNC_UNITS: {
                    START: "COLLECTION/PRODUCT/INVENTORY/SYNC_UNITS/STAR",
                    COMPLETED: "COLLECTION/PRODUCT/INVENTORY/SYNC_UNITS/COMPLETED",
                    STOP: "COLLECTION/PRODUCT/INVENTORY/SYNC_UNITS/STOP",
                },
            },
        },
        BUDGET: {
            CALCULATE: {
                CALCULATE_ALL_START: "COLLECTION/BUDGET/CALCULATE/CALCULATE_ALL_START",
                START: "COLLECTION/BUDGET/CALCULATE/START",
                COMPLETED: "COLLECTION/BUDGET/CALCULATE/COMPLETED",
                MUTATION: {
                    START: "COLLECTION/BUDGET/CALCULATE/MUTATION/START",
                    COMPLETED: "COLLECTION/BUDGET/CALCULATE/MUTATION/COMPLETED",
                },
            },
        },
        FILTER: {
            DOORS: {
                SET: "COLLECTION/FILTER/DOORS/SET",
            },
        },
        DOOR_TOTALS: {
            CALCULATE_FOR_MATCHING_ROWS: "COLLECTION/DOOR_TOTALS/CALCULATE_FOR_MATCHING_ROWS",
            CALCULATION_RETURNED: "COLLECTION/DOOR_TOTALS/CALCULATION_RETURNED",
            SET_DOOR_TOTAL_DELTA_QUEUE: "COLLECTION/DOOR_TOTALS/SET_DOOR_TOTAL_DELTA_QUEUE",
        },
        DOOR_TOTALS_FILTERED: {
            CALCULATE_FOR_MATCHING_ROWS: "COLLECTION/DOOR_TOTALS_FILTERED/CALCULATE_FOR_MATCHING_ROWS",
            CALCULATION_RETURNED: "COLLECTION/DOOR_TOTALS_FILTERED/CALCULATION_RETURNED",
        },
        DOOR_TOTAL_ROW_FILTERED: {
            CALCULATION_RETURNED: "COLLECTION/DOOR_TOTAL_ROW_FILTERED/CALCULATION_RETURNED",
        },
        PURCHASE_ORDERS: {
            FETCH: {
                START: "COLLECTION/PURCHASE_ORDERS/FETCH/START",
                COMPLETED: "COLLECTION/PURCHASE_ORDERS/FETCH/COMPLETED",
            },
            CREATE: {
                START: "COLLECTION/PURCHASE_ORDERS/CREATE/START",
                COMPLETED: "COLLECTION/PURCHASE_ORDERS/CREATE/COMPLETED",
            },
        },
        PURCHASE_ORDER: {
            CREATE: {
                START: "COLLECTION/PURCHASE_ORDER/CREATE/START",
                COMPLETED: "COLLECTION/PURCHASE_ORDER/CREATE/COMPLETED",
            },
            FETCH: {
                START: "COLLECTION/PURCHASE_ORDER/FETCH/START",
                COMPLETED: "COLLECTION/PURCHASE_ORDER/FETCH/COMPLETED",
            },
            UPDATE: {
                START: "COLLECTION/PURCHASE_ORDER/UPDATE/START",
                COMPLETED: "COLLECTION/PURCHASE_ORDER/UPDATE/COMPLETED",
            },
            DELETE: {
                START: "COLLECTION/PURCHASE_ORDER/DELETE/START",
                COMPLETED: "COLLECTION/PURCHASE_ORDER/DELETE/COMPLETED",
            },
        },
        ALLOCATIONS: {
            CLEAR: "COLLECTION/ALLOCATIONS/CLEAR",
            ALLOCATE: {
                START: "COLLECTION/ALLOCATIONS/ALLOCATE/STAR",
                COMPLETED: "COLLECTION/ALLOCATIONS/ALLOCATE/COMPLETED",
                STOP: "COLLECTION/ALLOCATIONS/ALLOCATE/STOP",
            },
            DOOR: {
                COPY: "COLLECTION/ALLOCATIONS/DOOR/COPY",
                COPY_COMPLETE: "COLLECTION/ALLOCATIONS/DOOR/COPY_COMPLETE",
                PASTE: "COLLECTION/ALLOCATIONS/DOOR/PASTE",
                CLEAR: "COLLECTION/ALLOCATIONS/DOOR/CLEAR",
            },
            SYNC_BULK_WITH_ALLOCATION: "COLLECTION/ALLOCATIONS/SYNC_BULK_WITH_ALLOCATION",
        },
        SUGGESTIONS: {
            FETCH: {
                START: "COLLECTION/SUGGESTIONS/FETCH/START",
                COMPLETED: "COLLECTION/SUGGESTIONS/FETCH/COMPLETED",
            },
        },
        VALIDATION_LOG: {
            MUTATE: "COLLECTION/VALIDATION_LOG/MUTATE",
            SYNC: {
                START: "COLLECTION/VALIDATION_LOG/SYNC/START",
                COMPLETE: "COLLECTION/VALIDATION_LOG/SYNC/COMPLETE",
            },
            AUTHORS: {
                FETCH: {
                    START: "COLLECTION/VALIDATION_LOG/AUTHORS/FETCH/START",
                    COMPLETED: "COLLECTION/VALIDATION_LOG/AUTHORS/FETCH/COMPLETED",
                },
            },
        },
        SIZE_PACKS: {
            FETCH: {
                START: "COLLECTION/SIZE_PACKS/FETCH/START",
                COMPLETED: "COLLECTION/SIZE_PACKS/FETCH/COMPLETED",
            },
            SET_TOLERANCE: {
                START: "COLLECTION/SIZE_PACKS/SET_TOLERANCE/START",
            },
        },
        SIZING: {
            SIZE_RANGES: {
                SET_SELECTED_SIZE_RANGE: "COLLECTION/SIZING/SIZE_RANGES/SET_SELECTED_SIZE_RANGE",
                RESET: "COLLECTION/SIZING/SIZE_RANGES/RESET",
                MATCH: {
                    START: "COLLECTION/SIZING/SIZE_RANGES/MATCH/START",
                    STOP: "COLLECTION/SIZING/SIZE_RANGES/MATCH/STOP",
                    MATCHED: "COLLECTION/SIZING/SIZE_RANGES/MATCH/MATCHED",
                    COMPLETED: "COLLECTION/SIZING/SIZE_RANGES/MATCH/COMPLETED",
                    ERROR: "COLLECTION/SIZING/SIZE_RANGES/MATCH/ERROR",
                },
                FETCH: {
                    START: "COLLECTION/SIZING/SIZE_RANGES/FETCH/START",
                    LOADING: "COLLECTION/SIZING/SIZE_RANGES/FETCH/LOADING",
                    COMPLETED: "COLLECTION/SIZING/SIZE_RANGES/FETCH/COMPLETED",
                    ERROR: "COLLECTION/SIZING/SIZE_RANGES/FETCH/ERROR",
                },
            },
            SYNC_SELECTED_SIZES: {
                START: "COLLECTION/SIZING/SYNC_SELECTED_SIZES/START",
            },
        },
        PENDING_MUTATION: {
            REQUEST_SAVE: "COLLECTION/PENDING_MUTATION/REQUEST_SAVE",
            SET: "COLLECTION/PENDING_MUTATION/SET",
            REQUEST_DELETE: "COLLECTION/PENDING_MUTATION/REQUEST_DELETE",
            APPLY: "COLLECTION/PENDING_MUTATION/APPLY",
        },
        ERROR: {
            SYNC_ERROR_THROW: "COLLECTION/ERROR/SYNC_ERROR_THROW",
            SYNC_ERROR_CLEAR: "COLLECTION/ERROR/SYNC_ERROR_CLEAR",
            ALLOCATION_LOOK_UP_ERROR: "COLLECTION/ERROR/ASSORTMENT/LOOK_UP",
            ALLOCATION_LOOK_UP_SET_ERROR: "COLLECTION/ERROR/ASSORTMENT/SET_ERROR",
        },
        REPORTING: {
            UPDATES: {
                START: "COLLECTION/REPORTING/UPDATES/START",
                COMPLETED: "COLLECTION/REPORTING/UPDATES/COMPLETED",
                TRANSIENT: "COLLECTION/REPORTING/UPDATES/TRANSIENT",
            },
        },
        TARGET_METRICS: {
            SAVE: "COLLECTION/TARGET_METRICS/TARGETS/SAVE",
            REMOVE: "COLLECTION/TARGET_METRICS/TARGETS/REMOVE",
            TARGET_GROUPS: {
                SYNC: {
                    START: "COLLECTION/TARGET_METRICS/TARGET_GROUPS/SYNC/START",
                    COMPLETED: "COLLECTION/TARGET_METRICS/TARGET_GROUPS/SYNC/COMPLETED",
                    ERROR: "COLLECTION/TARGET_METRICS/TARGET_GROUPS/SYNC/ERROR",
                    CONFLICT: "COLLECTION/TARGET_METRICS/TARGET_GROUPS/SYNC/CONFLICT",
                },
            },
            BAG_VALUE: {
                BULK_MUTATE: "COLLECTION/TARGET_METRICS/BAG_VALUE/BULK_MUTATE",
                SYNC: {
                    START: "COLLECTION/TARGET_METRICS/BAG_VALUE/SYNC/START",
                    COMPLETE: "COLLECTION/TARGET_METRICS/BAG_VALUE/SYNC/COMPLETE",
                },
            },
            TARGETS: {
                SYNC: {
                    START: "COLLECTION/TARGET_METRICS/TARGETS/SYNC/START",
                    COMPLETED: "COLLECTION/TARGET_METRICS/TARGETS/SYNC/COMPLETED",
                    ERROR: "COLLECTION/TARGET_METRICS/TARGETS/SYNC/ERROR",
                    CONFLICT: "COLLECTION/TARGET_METRICS/TARGETS/SYNC/CONFLICT",
                },
            },
            QUEUE: {
                CREATE: "COLLECTION/TARGET_METRICS/QUEUE/CREATE",
                EXECUTE: "COLLECTION/TARGET_METRICS/QUEUE/EXECUTE",
                SHIFT: "COLLECTION/TARGET_METRICS/QUEUE/SHIFT",
                CLEAR: "COLLECTION/TARGET_METRICS/QUEUE/CLEAR",
                UPDATE_TYPE: "COLLECTION/TARGET_METRICS/QUEUE/UPDATE_TYPE",
            } as const,
        },
        DISTRIBUTION: {
            MODAL: {
                OPEN: "COLLECTION/TARGET_METRICS/DISTRIBUTION/MODAL/OPEN",
                CLOSE: "COLLECTION/TARGET_METRICS/DISTRIBUTION/MODAL/CLOSE",
            },
            SELECT: "COLLECTION/TARGET_METRICS/DISTRIBUTION/SELECT",
        },
    },
    COLLECTION_STREAM: {
        STREAM: "COLLECTION/COLLECTION_STREAM/STREAM",
    },
    COLLECTION_MEDIA: {
        CREATE: {
            START: "COLLECTION/MEDIA/CREATE/START",
            COMPLETED: "COLLECTION/MEDIA/CREATE/COMPLETED",
        },
        DELETE: {
            START: "COLLECTION/MEDIA/DELETE/START",
            COMPLETED: "COLLECTION/MEDIA/DELETE/COMPLETED",
        },
    },
    COLLECTION_SIDE_PANEL: {
        BRAND: {
            FETCH: {
                START: "COLLECTION/SIDE_PANEL/BRAND/FETCH/START",
                COMPLETED: "COLLECTION/SIDE_PANEL/BRAND/FETCH/COMPLETED",
            },
        },
        BRANDS: {
            FETCH: {
                START: "COLLECTION/SIDE_PANEL/BRANDS/FETCH/START",
                COMPLETED: "COLLECTION/SIDE_PANEL/BRANDS/FETCH/COMPLETED",
                CANCEL: "COLLECTION/SIDE_PANEL/BRANDS/FETCH/CANCEL",
            },
        },
        SINGLE_BRAND: {
            FETCH: {
                START: "COLLECTION/SIDE_PANEL/SINGLE_BRAND/FETCH/START",
                COMPLETED: "COLLECTION/SIDE_PANEL/SINGLE_BRAND/FETCH/COMPLETED",
            },
        },
    },
    COLLECTION_BUDGET: {
        UPDATES: {
            SUBSCRIBE: "COLLECTION/BUDGET/UPDATES/SUBSCRIBE",
            UNSUBSCRIBE: "COLLECTION/BUDGET/UPDATES/UNSUBSCRIBE",
            POLL: "COLLECTION/BUDGET/UPDATES/POLL",
            RECEIVED: "COLLECTION/BUDGET/UPDATES/RECEIVED",
        },
        SYNC: {
            START: "COLLECTION/BUDGET/SYNC/START",
            COMPLETED: "COLLECTION/BUDGET/SYNC/COMPLETED",
            CONFLICT: "COLLECTION/BUDGET/SYNC/CONFLICT",
            ERROR: "COLLECTION/BUDGET/SYNC/ERROR",
        },
        MUTATE: "COLLECTION/BUDGET/ITEM/MUTATE",
    },
    COLLECTION_BUDGET_ACTUALS: {
        UPDATES: {
            SUBSCRIBE: "COLLECTION/BUDGET_ACTUALS/UPDATES/SUBSCRIBE",
            UNSUBSCRIBE: "COLLECTION/BUDGET_ACTUALS/UPDATES/UNSUBSCRIBE",
            POLL: "COLLECTION/BUDGET_ACTUALS/UPDATES/POLL",
            RECEIVED: "COLLECTION/BUDGET_ACTUALS/UPDATES/RECEIVED",
        },
        SYNC: {
            START: "COLLECTION/BUDGET_ACTUAL/SYNC/START",
            COMPLETED: "COLLECTION/BUDGET_ACTUAL/SYNC/COMPLETED",
            CONFLICT: "COLLECTION/BUDGET_ACTUAL/SYNC/CONFLICT",
            ERROR: "COLLECTION/BUDGET_ACTUAL/SYNC/ERROR",
        },
    },
    COLLECTION_CHAT: {
        FETCH_MESSAGES: {
            START: "COLLECTION/CHAT/FETCH/START",
            COMPLETED: "COLLECTION/CHAT/FETCH/COMPLETED",
        },
        CREATE_MESSAGE: {
            START: "COLLECTION/CHAT/CREATE/START",
            COMPLETED: "COLLECTION/CHAT/CREATE/COMPLETED",
        },
        DELETE_MESSAGE: {
            START: "COLLECTION/CHAT/DELETE/START",
            COMPLETED: "COLLECTION/CHAT/DELETE/COMPLETED",
        },
        UPDATES: {
            SUBSCRIBE: "COLLECTION/CHAT/UPDATES/SUBSCRIBE",
            UNSUBSCRIBE: "COLLECTION/CHAT/UPDATES/UNSUBSCRIBE",
            POLL: "COLLECTION/CHAT/UPDATES/POLL",
            RECEIVED: "COLLECTION/CHAT/UPDATES/RECEIVED",
        },
        RESET: "COLLECTION/CHAT/RESET",
    },
};

export const COMPANY_DISCOUNTS = baseTypes("COMPANY_DISCOUNTS");

export const LIFECYCLE_SCRIPTS = {
    FETCH: progressTypes("LIFECYCLE_SCRIPTS"),
};

function uploadTypes(key: string) {
    return {
        PROCESS: progressTypes(key, "PROCESS"),
        UPLOAD: {
            ...progressTypes(key, "UPLOAD"),
            RESET_STATE: `${key}/UPLOAD/RESET_STATE`,
        },
        JOB: {
            POLL: {
                START: `${key}/JOB/POLL/START`,
                STOP: `${key}/JOB/POLL/STOP`,
            },
            FETCH: progressTypes(`${key}/JOB/FETCH`),
            RESET: `${key}/JOB/RESET`,
        },
    };
}

function exportTypes(key: string) {
    return {
        PROCESS: progressTypes(key, "PROCESS"),
        DOWNLOAD: {
            ...progressTypes(key, "DOWNLOAD"),
            RESET_STATE: `${key}/DOWNLOAD/RESET_STATE`,
        },
        JOB: {
            POLL: {
                START: `${key}/JOB/POLL/START`,
                STOP: `${key}/JOB/POLL/STOP`,
            },
            FETCH: progressTypes(`${key}/JOB/FETCH`),
        },
    };
}

export function progressTypes(key: string, action = "FETCH") {
    return {
        START: `${key}/${action}/START`,
        SUCCESS: `${key}/${action}/SUCCESS`,
        ERROR: `${key}/${action}/FAILURE`,
        CANCEL: `${key}/${action}/CANCEL`,
    };
}

function baseTypes(key: string) {
    return {
        FETCH: progressTypes(key),
        UPDATE: `${key}/UPDATE`,
    };
}

export const POS = {
    STATUS: baseTypes("POS/STATUS"),
};

export const TEMPLATE = baseTypes("TEMPLATE"); //advanced way is better, need only base types 1. create a constant
export const TEMPLATES = baseTypes("TEMPLATES");
export const NOTES = baseTypes("NOTES");

export const INVENTORY = {
    REPLENISHMENTS: {
        ...baseTypes("INVENTORY/REPLENISHMENTS"),
        REQUEST: "INVENTORY/REPLENISHMENTS/REQUEST",
        REPLACE: "INVENTORY/REPLENISHMENTS/REPLACE",
    },
    WAREHOUSES: baseTypes("INVENTORY/WAREHOUSES"),
};

export const ORDER_INTENTS = baseTypes("ORDERS_INTENT");

export const AUTHENTICATION = {
    FORGOT_PASSWORD: {
        START: "LOGIN/FORGOT_PASSWORD/START",
        COMPLETED: "LOGIN/FORGOT_PASSWORD/COMPLETED",
        RESET: "LOGIN/FORGOT_PASSWORD/RESET",
    },
};

export const SCOPE = {
    BRANDED_LOGIN: {
        START: "SCOPE/BRANDED_LOGIN/START",
        COMPLETED: "SCOPE/BRANDED_LOGIN/COMPLETED",
        SPINNER: "SCOPE/BRANDED_LOGIN/SPINNER",
    },
    COMPANIES: {
        START: "SCOPE/COMPANIES/START",
        COMPLETED: "SCOPE/COMPANIES/COMPLETED",
    },
};

export const GLOBAL = {
    PRODUCT: {
        FETCH: {
            START: "GLOBAL/PRODUCT/FETCH/START",
            COMPLETED: "GLOBAL/PRODUCT/FETCH/COMPLETED",
        },
    },
    PRODUCTS: {
        FETCH: {
            START: "GLOBAL/PRODUCTS/FETCH/START",
            NEXT: "GLOBAL/PRODUCTS/FETCH/NEXT",
            COMPLETED: "GLOBAL/PRODUCTS/FETCH/COMPLETED",
        },
        RESET: "GLOBAL/PRODUCTS/RESET",
        VARIANTS: {
            FETCH: {
                START: "GLOBAL/PRODUCTS/VARIANTS/FETCH/START",
                COMPLETED: "GLOBAL/PRODUCTS/VARIANTS/FETCH/COMPLETED",
            },
        },
    },
};

export const GENERIC_FILTERS = {
    FETCH: progressTypes("GENERIC_FILTERS"),
    RESET: "GENERIC_FILTERS/RESET",
};

export const GET_FILTERS_GROUPS = {
    FETCH: progressTypes("GET_FILTERS_GROUPS"),
    RESET: "GET_FILTERS_GROUPS/RESET",
};

export const UTILITIES = {
    USERS: {
        FETCH: progressTypes("UTILITIES/USERS"),
        CREATE: progressTypes("UTILITIES/USERS", "CREATE"),
        EDIT: progressTypes("UTILITIES/USERS", "EDIT"),
        DELETE: progressTypes("UTILITIES/USERS", "DELETE"),
        DISABLE: progressTypes("UTILITIES/USERS", "DISABLE"),
        RESTORE: progressTypes("UTILITIES/USERS", "RESTORE"),
        LOOKUP: {
            FETCH: progressTypes("UTILITIES/USERS/LOOKUP"),
            COLLECTIONS: {
                FETCH: progressTypes("UTILITIES/USERS/LOOKUP/COLLECTIONS"),
            },
            CLEAR: "UTILITIES/USERS/LOOKUP/CLEAR",
        },
    },
    ACTIVE_STATUSES: {
        FETCH: progressTypes("UTILITIES/ACTIVE_STATUSES"),
        PAGINATED: progressTypes("UTILITIES/ACTIVE_STATUSES/PAGINATED"),
        CLEAR: "UTILITIES/ACTIVE_STATUSES/CLEAR",
    },
    USER_PERMISSION_TYPES: {
        FETCH: progressTypes("UTILITIES/USER_PERMISSION_TYPES"),
    },
    ASSORTMENT_BUYERS: {
        BUYERS: baseTypes("ASSORTMENT_BUYERS"),
        SUGGESTIONS: baseTypes("ASSORTMENT_BUYERS/SUGGESTIONS"),
    },
    ASSORTMENT_SUPERUSERS: {
        SUPERUSERS: baseTypes("ASSORTMENT_SUPERUSERS"),
        SUGGESTIONS: baseTypes("ASSORTMENT_SUPERUSERS/SUGGESTIONS"),
    },
    DATAFLOW_MANAGEMENT: {
        BRAND_DETAILED: baseTypes("UTILITIES/DATAFLOW_MANAGEMENT/BRAND_DETAILED"),
        BRANDS: baseTypes("UTILITIES/DATAFLOW_MANAGEMENT/BRANDS"),
        FLOW: {
            ...baseTypes("UTILITIES/DATAFLOW_MANAGEMENT/FLOW"),
            RESET: "UTILITIES/DATAFLOW_MANAGEMENT/FLOW/RESET",
            SAVE: "UTILITIES/DATAFLOW_MANAGEMENT/FLOW/SAVE",
        },
        FLOW_V2: {
            UPDATE: "UTILITIES/DATAFLOW_MANAGEMENT/FLOW_V2/UPDATE",
        },
        BRAND_FLOW: {
            ...baseTypes("UTILITIES/DATAFLOW_MANAGEMENT/BRAND_DATA_FLOW"),
            RESET: "UTILITIES/DATAFLOW_MANAGEMENT/FLOW/BRAND_DATA_RESET",
            SAVE: "UTILITIES/DATAFLOW_MANAGEMENT/FLOW/BRAND_DATA_SAVE",
        },
    },
    MERCHANTS: baseTypes("ASSORTMENT_BUYERS/MERCHANTS"),
};

export const CONTACTS = {
    ACCOUNTS: baseTypes("CONTACTS"),
    BUYER: {
        FETCH: progressTypes("CONTACTS/BUYER"),
        UPDATE: progressTypes("CONTACTS/BUYER", "UPDATE"),
        DELETE: "CONTACTS/BUYER/DELETE",
        CREATE: "CONTACTS/BUYER/CREATE",
    },
    COMPANY: {
        FETCH: progressTypes("CONTACTS/COMPANY"),
        UPDATE: progressTypes("CONTACTS/COMPANY", "UPDATE"),
        DELETE: "CONTACTS/COMPANY/DELETE",
        CREATE: "CONTACTS/COMPANY/CREATE",
        API: {
            GET: "CONTACTS/COMPANY/API/GET",
            UPDATE: "CONTACTS/COMPANY/API/UPDATE",
            GENERATE_KEYS: "CONTACTS/COMPANY/API/GENERATE_KEYS",
            APPROVE: "CONTACTS/COMPANY/API/APPLICATION/APPROVE",
            DISABLE: "CONTACTS/COMPANY/API/APPLICATION/DISABLE",
        },
    },
    HEADERS: baseTypes("CONTACTS/HEADERS"),
};

export const RECENT_ORDERS = baseTypes("RECENT_ORDERS");

export const BUYER_SETUP_GUIDE = {
    ...baseTypes("BUYER_SETUP_GUIDE"),
    DISMISS: progressTypes("BUYER_SETUP_GUIDE", "DISMISS"),
};

export const WARNING_REDIRECT = {
    UPDATE: "WARNING_REDIRECT/UPDATE",
    CLEAR: "WARNING_REDIRECT/CLEAR",
};

export const PROCESS_ADD_LINE_ITEM_RESULT = "WORKING/LINE_ITEM/PROCESS_ADD_RESULT";
export const PROCESS_REDUX_ACTION_GENERAL_ERROR = "WORKING/REDUX_ACTIONS/GENERAL_ERROR";

export const COMPANIES = {
    FETCH: progressTypes("COMPANIES"),
};

export const WORKING_ORDER = {
    ORDER: baseTypes("WORKING/ORDER"),
    COMPANY: {
        SET: "WORKING/COMPANY/SET",
    },
    FETCH_CART: "WORKING/FETCH_CART",
    LINE_ITEM: {
        ADD: progressTypes("WORKING/LINE_ITEM", "ADD"),
        SEND_RESULT: "WORKING/LINE_ITEM/SEND_RESULT",
    },
    PRODUCTS: {
        RESET: "WORKING/PRODUCTS/RESET",
        FETCH: {
            ...progressTypes("WORKING/PRODUCTS", "FETCH"),
            COMPLETE: "WORKING/PRODUCTS/FETCH/COMPLETE",
        },
    },
    AVAILABILITY: {
        PRODUCTS_CACHE: {
            CLEAR: "WORKING_ORDER/AVAILABILITY/PRODUCTS_CACHE/CLEAR",
        },
        FETCH: progressTypes("WORKING_ORDER/AVAILABILITY", "FETCH"),
    },
    DRAFTS: {
        ...baseTypes("WORKING_ORDER/DRAFTS"),
        VALIDATE: "WORKING_ORDER/DRAFTS/VALIDATE",
        SAVE: progressTypes("WORKING_ORDER/DRAFTS", "SAVE"),
    },
    ORDER_PROMOTIONS: {
        FETCH: "WORKING_ORDER/ORDER_PROMOTIONS",
    },
    LOAD_INVENTORY: "WORKING_ORDER/LOAD_INVENTORY",
    REPLACE_INVENTORY: "WORKING_ORDER/REPLACE_INVENTORY",
};

export const SHIPPING_RATES = {
    FETCH: progressTypes("SHIPPING_RATES"),
};

export const CANCELLED_STYLES = {
    ORDERS: {
        COUNT: "CANCELLED_STYLES/ORDERS/COUNT",
        UPDATE: "CANCELLED_STYLES/ORDERS/UPDATE",
        DROP: "CANCELLED_STYLES/ORDERS/DROP",
    },
    STYLES: {
        ...baseTypes("CANCELLED_STYLES/STYLES"),
        COUNT: "CANCELLED_STYLES/STYLES/COUNT",
    },
    STYLE: baseTypes("CANCELLED_STYLES/STYLE"),
    ORDER_STYLES: baseTypes("CANCELLED_STYLES/ORDER_STYLES"),
    ORDER: baseTypes("CANCELLED_STYLES/ORDER"),
    DROP: progressTypes("CANCELLED_STYLES", "DROP"),
};

export const NOTIFICATIONS = {
    FEED_NOTIFICATIONS: {
        ...baseTypes("NOTIFICATIONS/FEED_NOTIFICATIONS"),
        STATUS: "NOTIFICATIONS/FEED_NOTIFICATIONS/STATUS",
    },
    FEEDS: baseTypes("FEEDS"),
    POLL: {
        START: "NOTIFICATIONS/FEEDS/START",
        STOP: "NOTIFICATIONS/FEEDS/POLL/STOP",
    },
};

export const WHITEBOARD_EXPORT_NOTIFICATIONS = {
    STATUS: "WHITEBOARD_EXPORT_NOTIFICATIONS/STATUS",
    UPDATE: "WHITEBOARD_EXPORT_NOTIFICATIONS/UPDATE",
};

export const COLLECTION_TIMELINE = baseTypes("COLLECTION_TIMELINE");

export const SUBSCRIPTION = {
    ...baseTypes("SUBSCRIPTION"),
    SUBSCRIBE: progressTypes("SUBSCRIPTION", "SUBSCRIBE"),
    UNSUBSCRIBE: progressTypes("SUBSCRIPTION", "UNSUBSCRIBE"),
};

export const SIZE_FAMILIES = {
    ...baseTypes("SIZE_FAMILIES"),
    CREATE: {
        START: "SIZE_FAMILIES/CREATE/START",
        COMPLETED: "SIZE_FAMILIES/CREATE/COMPLETED",
    },
    DELETE: {
        START: "SIZE_FAMILIES/DELETE/START",
        COMPLETED: "SIZE_FAMILIES/DELETE/COMPLETED",
    },
    UPDATE: {
        START: "SIZE_FAMILIES/UPDATE/START",
        COMPLETED: "SIZE_FAMILIES/UPDATE/COMPLETED",
    },
};

export const SIZE_OVERRIDE = {
    ...baseTypes("SIZE_OVERRIDE"),
    CREATE: {
        START: "SIZE_OVERRIDE/CREATE/START",
        COMPLETED: "SIZE_OVERRIDE/CREATE/COMPLETED",
    },
    DELETE: {
        START: "SIZE_OVERRIDE/DELETE/START",
        COMPLETED: "SIZE_OVERRIDE/DELETE/COMPLETED",
    },
    UPDATE: {
        START: "SIZE_OVERRIDE/UPDATE/START",
        COMPLETED: "SIZE_OVERRIDE/UPDATE/COMPLETED",
    },
};

export const BRAND_SIZE_OVERRIDES = {
    ...baseTypes("BRAND_SIZE_OVERRIDES"),
    CREATE: {
        START: "BRAND_SIZE_OVERRIDES/CREATE/START",
        COMPLETED: "BRAND_SIZE_OVERRIDES/CREATE/COMPLETED",
    },
    DELETE: {
        START: "BRAND_SIZE_OVERRIDES/DELETE/START",
        COMPLETED: "BRAND_SIZE_OVERRIDES/DELETE/COMPLETED",
    },
    UPDATE: {
        START: "BRAND_SIZE_OVERRIDES/UPDATE/START",
        COMPLETED: "BRAND_SIZE_OVERRIDES/UPDATE/COMPLETED",
    },
};

export const SIZE_COMPLIANCE_REPORT = {
    CREATE: {
        START: "SIZE_COMPLIANCE_REPORT/CREATE/START",
        COMPLETED: "SIZE_COMPLIANCE_REPORT/CREATE/COMPLETED",
        ERROR: "SIZE_COMPLIANCE_REPORT/CREATE/ERROR",
    },
    CLEAR_REPORT_DATA: "SIZE_COMPLIANCE_REPORT/CLEAR_REPORT_DATA",
};

export const PRODUCT_MEDIA = {
    FETCH: progressTypes("MEDIA_ASSETS"),
    UPLOAD: progressTypes("PRODUCT_MEDIA/UPLOAD"),
    MUTATE: progressTypes("PRODUCT_MEDIA/MUTATE"),
    UPDATE: "PRODUCT_MEDIA/UPDATE",
    RESET: "PRODUCT_MEDIA/UPDATE",
    MEDIA_ASSETS: {
        MUTATE: progressTypes("PRODUCT_MEDIA/MEDIA_ASSETS/MUTATE"),
        FETCH: progressTypes("PRODUCT_MEDIA/MEDIA_ASSETS"),
        RESET: "PRODUCT_MEDIA/MEDIA_ASSETS/UPDATE",
    },
    IMAGE_360: {
        MANIFEST: progressTypes("PRODUCT_MEDIA/360/MANIFEST"),
    },
};

export const UNLINKED_MEDIA = {
    FETCH: progressTypes("UNLINKED_MEDIA"),
    RESET: "UNLINKED_MEDIA/UPDATE",
    LINK: progressTypes("UNLINKED_MEDIA", "LINK"),
    UPDATE_LINKS_STATE: progressTypes("UNLINKED_MEDIA", "UPDATE_LINKS_STATE"),
};

export const PAYMENTS_MANAGEMENT = {
    CHARGEBACKS: {
        FETCH: {
            START: "PAYMENTS_MANAGEMENT/CHARGEBACKS/FETCH/START",
            COMPLETED: "PAYMENTS_MANAGEMENT/CHARGEBACKS/FETCH/COMPLETED",
        },
        FILTERCHANGE: "PAYMENTS_MANAGEMENT/CHARGEBACKS/FILTERCHANGE",
    },
    CHARGEBACK: {
        FETCH: {
            START: "PAYMENTS_MANAGEMENT/CHARGEBACK/FETCH/START",
            COMPLETED: "PAYMENTS_MANAGEMENT/CHARGEBACK/FETCH/COMPLETED",
        },
        EVIDENCE: {
            CREATE: {
                START: "PAYMENTS_MANAGEMENT/CHARGEBACK/EVIDENCE/CREATE/START",
                COMPLETED: "PAYMENTS_MANAGEMENT/CHARGEBACK/EVIDENCE/CREATE/COMPLETED",
            },
            DELETE: {
                START: "PAYMENTS_MANAGEMENT/CHARGEBACK/EVIDENCE/DELETE/START",
                COMPLETED: "PAYMENTS_MANAGEMENT/CHARGEBACK/EVIDENCE/DELETE/COMPLETED",
            },
            SUBMIT: {
                START: "PAYMENTS_MANAGEMENT/CHARGEBACK/EVIDENCE/SUBMIT/START",
                COMPLETED: "PAYMENTS_MANAGEMENT/CHARGEBACK/EVIDENCE/SUBMIT/COMPLETED",
            },
        },
    },
    STATEMENTS: {
        FETCH: {
            START: "PAYMENTS_MANAGEMENT/STATEMENTS/FETCH/START",
            COMPLETED: "PAYMENTS_MANAGEMENT/STATEMENTS/FETCH/COMPLETED",
        },
        CREATE: {
            START: "PAYMENTS_MANAGEMENT/STATEMENTS/CREATE/START",
            COMPLETED: "PAYMENTS_MANAGEMENT/STATEMENTS/CREATE/COMPLETED",
        },
    },
    TRANSACTIONS: {
        FETCH: {
            START: "PAYMENTS_MANAGEMENT/TRANSACTIONS/FETCH/START",
            COMPLETED: "PAYMENTS_MANAGEMENT/TRANSACTIONS/FETCH/COMPLETED",
        },
        DOWNLOAD_CREATE: {
            START: "PAYMENTS_MANAGEMENT/TRANSACTION_DOWNLOAD/CREATE/START",
            COMPLETED: "PAYMENTS_MANAGEMENT/TRANSACTION_DOWNLOAD/CREATE/COMPLETED",
        },
    },
    SUMMARY: {
        FETCH: {
            START: "PAYMENTS_MANAGEMENT/SUMMARY/FETCH/START",
            COMPLETED: "PAYMENTS_MANAGEMENT/SUMMARY/FETCH/COMPLETED",
        },
        FILTERS_UPDATE: "PAYMENTS_MANAGEMENT/FILTERS/UPDATE",
    },
};

export const UPLOAD_BUYERS = {
    UPLOAD: {
        ...progressTypes("UPLOAD_BUYERS", "UPLOAD"),
        CANCEL_UPLOADING: "UPLOAD_BUYERS/CANCEL_UPLOADING",
    },
};

export const COLOR_SWATCHES = {
    LIST: {
        ...baseTypes("COLOR_SWATCHES/LIST"),
        SET: progressTypes("COLOR_SWATCHES/LIST", "SET"),
        DELETE: "COLOR_SWATCHES/LIST/DELETE",
    },
    IMPORT: {
        UPDATE: "COLOR_SWATCHES/IMPORT/UPDATE",
        UPLOAD: progressTypes("COLOR_SWATCHES/IMPORT", "UPLOAD"),
    },
    EXPORT: {
        UPDATE: "COLOR_SWATCHES/EXPORT/UPDATE",
        DOWNLOAD: progressTypes("COLOR_SWATCHES/EXPORT", "DOWNLOAD"),
    },
};

export const VARIANTS = baseTypes("VARIANTS");

export const INVENTORY_DATA = {
    UPLOAD_NON_VETL: progressTypes("INVENTORY_DATA", "UPLOAD_NON_VETL"),
    ...uploadTypes("INVENTORY_DATA"),
    UPDATE: "INVENTORY_DATA/UPDATE",
    DOWNLOAD: "INVENTORY_DATA/DOWNLOAD",
    DOWNLOAD_ATS: "INVENTORY_DATA/DOWNLOAD_ATS",
    DELETE_ALL: "INVENTORY_DATA/DELETE_ALL",
};
export const COMPANY_DATA = uploadTypes("COMPANY_DATA");
export const BUYER_DATA = uploadTypes("BUYER_DATA");
export const PRODUCT_DATA = {
    EXPORT: {
        DOWNLOAD: progressTypes("PRODUCT_DATA/EXPORT", "DOWNLOAD"),
        RESET: "PRODUCT_DATA/EXPORT/RESET",
    },
    ARCHIVE: progressTypes("PRODUCT_DATA/ARCHIVE", "ARCHIVE"),
    ...uploadTypes("PRODUCT_DATA"),
};

export const PRICE_SHEETS = uploadTypes("PRICE_SHEETS");
export const PRODUCT_IMAGES = uploadTypes("PRODUCT_IMAGES");

export const SIZE_PACKS = {
    UPLOAD: progressTypes("SIZE_PACKS/UPLOAD"),
    UPDATE_IMPORT: "SIZE_PACKS/UPDATE/IMPORT",
    UPDATE_EXPORT: "SIZE_PACKS/UPDATE/EXPORT",
    JOB: {
        POLL: {
            START: "SIZE_PACKS/JOB/POLL/START",
            STOP: "SIZE_PACKS/JOB/POLL/STOP",
        },
        FETCH: progressTypes("SIZE_PACKS/JOB/FETCH"),
    },
    EXPORT: exportTypes("SIZE_PACKS/EXPORT"),
    EXPORT_FILE: {
        FETCH: progressTypes("SIZE_PACKS/EXPORT_FILE/FETCH"),
    },
};

export const ATS_CUSTOM_TEMPLATES = {
    CREATE: progressTypes("ATS_CUSTOM_TEMPLATES", "CREATE"),
    FETCH: progressTypes("ATS_CUSTOM_TEMPLATES", "FETCH"),
    MUTATE: progressTypes("ATS_CUSTOM_TEMPLATES", "MUTATE"),
    DELETE: progressTypes("ATS_CUSTOM_TEMPLATES", "DELETE"),
    UPDATE: "ATS_CUSTOM_TEMPLATES/UPDATE",
    FIELD: {
        ADD: progressTypes("ATS_CUSTOM_TEMPLATES/FIELD", "ADD"),
        ORDER: progressTypes("ATS_CUSTOM_TEMPLATES/FIELD", "ORDER"),
        MUTATE: progressTypes("ATS_CUSTOM_TEMPLATES/FIELD", "MUTATE"),
        DELETE: progressTypes("ATS_CUSTOM_TEMPLATES/FIELD", "DELETE"),
        SORT: progressTypes("ATS_CUSTOM_TEMPLATES/FIELD", "SORT"),
    },
    LIST: {
        ...baseTypes("ATS_CUSTOM_TEMPLATES/LIST"),
    },
};

export const ATS_EXPORT = {
    INITIATE: progressTypes("ATS_EXPORT", "INITIATE"),
    UPDATE: "ATS_EXPORT/UPDATE",
};

export const MERCHANT_ADMIN_ACCOUNT = {
    MERCHANT: {
        FETCH: progressTypes("MERCHANT_ADMIN_ACCOUNT/MERCHANT", "FETCH"),
    },
};

export const MERCHANT_ADMIN_MEMBER_LIST = {
    MEMBERS: {
        FETCH: progressTypes("MERCHANT_ADMIN_MEMBER_LIST/MEMBERS", "FETCH"),
        UPDATE: "MERCHANT_ADMIN_MEMBER_LIST/MEMBERS/UPDATE",
        ADD: progressTypes("MERCHANT_ADMIN_MEMBER_LIST/MEMBERS", "ADD"),
        RESET: "MERCHANT_ADMIN_MEMBER_LIST/MEMBERS/RESET",
    },
    MEMBER: {
        DEACTIVATE: progressTypes("MERCHANT_ADMIN_MEMBER_LIST/MEMBER/DEACTIVATE"),
        ACTIVATE: progressTypes("MERCHANT_ADMIN_MEMBER_LIST/MEMBER/ACTIVATE"),
    },
    SUCCESS_MESSAGE: {
        SET: "MERCHANT_ADMIN_MEMBER_LIST/SUCCESS_MESSAGE/SET",
        CLEAR: "MERCHANT_ADMIN_MEMBER_LIST/SUCCESS_MESSAGE/CLEAR",
    },
    ERROR_MESSAGE: {
        SET: "MERCHANT_ADMIN_MEMBER_LIST/ERROR_MESSAGE/SET",
        CLEAR: "MERCHANT_ADMIN_MEMBER_LIST/ERROR_MESSAGE/CLEAR",
    },
};

export const MERCHANT_ADMIN_MEMBER_DETAILS = {
    MEMBER: {
        FETCH: progressTypes("MERCHANT_ADMIN_MEMBER_DETAILS/MEMBER", "FETCH"),
        DEACTIVATE: progressTypes("MERCHANT_ADMIN_MEMBER_DETAILS/MEMBER/DEACTIVATE"),
        ACTIVATE: progressTypes("MERCHANT_ADMIN_MEMBER_DETAILS/MEMBER/ACTIVATE"),
    },
    MEMBER_BASIC_PROFILE: {
        FETCH: progressTypes("MERCHANT_ADMIN_MEMBER_DETAILS/MEMBER_BASIC_PROFILE", "FETCH"),
        MUTATE: progressTypes("MERCHANT_ADMIN_MEMBER_DETAILS/MEMBER_BASIC_PROFILE", "MUTATE"),
    },
    SUCCESS_MESSAGE: {
        SET: "MERCHANT_ADMIN_MEMBER_DETAILS/SUCCESS_MESSAGE/SET",
        CLEAR: "MERCHANT_ADMIN_MEMBER_DETAILS/SUCCESS_MESSAGE/CLEAR",
    },
    ERROR_MESSAGE: {
        SET: "MERCHANT_ADMIN_MEMBER_DETAILS/ERROR_MESSAGE/SET",
        CLEAR: "MERCHANT_ADMIN_MEMBER_DETAILS/ERROR_MESSAGE/CLEAR",
    },
};

export const BRANDS_DATA = {
    FETCH: progressTypes("BRANDS_DATA"),
};

export const CUSTOMIZATION = {
    PRODUCT_TEMPLATES: {
        FETCH: progressTypes("CUSTOMIZATION_PRODUCT_TEMPLATES", "FETCH"),
    },
    SET_SELECTION: "CUSTOMIZATION_SET_SELECTION",
    EDIT_LINE_ITEM: "CUSTOMIZATION_EDIT_LINE_ITEM",
    PROOF_WARNING_MODAL: "PROOF_WARNING_MODAL",
    BULK_CUSTOMIZATIONS_MODAL: "CUSTOMIZATION_BULK_CUSTOMIZATIONS_MODAL",
    BULK_CUSTOMIZATIONS: {
        PRODUCTS: {
            FETCH: progressTypes("CUSTOMIZATION_BULK_CUSTOMIZATIONS_PRODUCTS", "FETCH"),
            CLEAR: "CUSTOMIZATION_BULK_CUSTOMIZATIONS_PRODUCTS/CLEAR",
        },
        RESET: "CUSTOMIZATION_BULK_CUSTOMIZATIONS/RESET",
    },
    CREATE_CUSTOMIZATION_IMAGE: {
        CREATE: progressTypes("CREATE_CUSTOMIZATION_IMAGE", "CREATE"),
        CLEAR: "CREATE_CUSTOMIZATION_IMAGE/CLEAR",
    },
    GET_CUSTOMIZATION_IMAGE_DOWNLOAD_URL: {
        FETCH: progressTypes("GET_CUSTOMIZATION_IMAGE_URL", "FETCH"),
        RESET: "GET_CUSTOMIZATION_IMAGE_URL/RESET",
    },
    LIST_CUSTOMIZATION_IMAGES: {
        FETCH: progressTypes("LIST_CUSTOMIZATION_IMAGES", "FETCH"),
        CHECK: progressTypes("LIST_CUSTOMIZATION_IMAGES", "CHECK"),
        CHECK_IMAGE_TAB: progressTypes("LIST_CUSTOMIZATION_IMAGES", "CHECK_IMAGE_TAB"),
        UPDATE: "LIST_CUSTOMIZATION_IMAGES/UPDATE",
        RESET: "LIST_CUSTOMIZATION_IMAGES/RESET",
        RESET_CHECKED: "LIST_CUSTOMIZATION_IMAGES/RESET_CHECKED",
        SET_STORED_VALUES: "LIST_CUSTOMIZATION_IMAGES/SET_STORED_VALUES",
        RESET_IMAGE_TAB: "LIST_CUSTOMIZATION_IMAGES/RESET_IMAGE_TAB",
        SEARCH: "LIST_CUSTOMIZATION_IMAGES/SEARCH",
    },
    LIST_MANAGE_LOGOS: {
        FETCH: progressTypes("LIST_MANAGE_LOGOS", "FETCH"),
        RESET: "LIST_MANAGE_LOGOS/RESET",
    },
    CUSTOMIZATION_LOGO_STATUS: {
        UPDATE: progressTypes("CUSTOMIZATION_PRODUCT", "UPDATE"),
    },
    PRODUCT: {
        FETCH: progressTypes("CUSTOMIZATION_PRODUCT", "FETCH"),
        RESET: "CUSTOMIZATION_PRODUCT/RESET",
    },
    ORDER: {
        CHECK: progressTypes("CUSTOMIZATION_ORDER", "CHECK"),
        FETCH: progressTypes("CUSTOMIZATION_ORDER", "FETCH"),
        RESET: "CUSTOMIZATION_ORDER/RESET",
    },
    COMPANY: {
        FETCH: progressTypes("CUSTOMIZATION_COMPANY", "FETCH"),
    },
    BRAND_SETTINGS: {
        UPDATE: progressTypes("CUSTOMIZATION/BRAND_SETTINGS/UPDATE", "START"),
        RESET_ERROR: "CUSTOMIZATION/BRAND_SETTINGS/RESET_ERROR",
        IMAGE_TYPES_RESET: "CUSTOMIZATION/BRAND_SETTINGS/IMAGE_TYPES_RESET",
    },
    IMAGE_TAG_SCHEMAS: {
        BRAND: {
            FETCH: progressTypes("CUSTOMIZATION/IMAGE_TAG_SCHEMAS/BRAND", "FETCH"),
        },
    },
    CUSTOMIZATION_IMAGE: {
        UPDATE: progressTypes("CUSTOMIZATION/CUSTOMIZATION_IMAGE/UPDATE", "START"),
    },
    PROOF: {
        CREATE: progressTypes("CUSTOMIZATION/PROOF/CREATE", "START"),
        UPLOAD: progressTypes("CUSTOMIZATION/PROOF/UPLOAD", "START"),
        ASSIGN: progressTypes("CUSTOMIZATION/PROOF/ASSIGN", "START"),
        RESET: "CUSTOMIZATION/PROOF/RESET",
    },
};

export const WATERMARKING = {
    PREVIEW: progressTypes("WATERMARKING", "PREVIEW"),
    UPDATE: progressTypes("WATERMARKING", "UPDATE"),
    FETCH: progressTypes("WATERMARKING", "FETCH"),
};

export const ACCESS_CONTROL = {
    HAS: {
        ACCESS: "ACCESS_CONTROL/HAS/ACCESS",
    },
    ERROR: {
        SET: "ACCESS_CONTROL/ERROR/SET",
        PROCESS: "ACCESS_CONTROL/ERROR/PROCESS",
    },
};

export const PROMOTIONS = {
    LIST: {
        FETCH: progressTypes("PROMOTIONS"),
        DELETE: "PROMOTIONS/DELETE",
        BULK_DELETE: "PROMOTIONS/BULK_DELETE",
        ADD: "PROMOTIONS/ADD",
        BULK_EDIT: "PROMOTIONS/BULK_EDIT",
        // TODO: Clean with promotionsEnablesElasticSearchFilteringNu64701 FF
        SET_APPLY_FILTERS: "PROMOTIONS/SET_APPLY_FILTERS",
        SET_FILTERS: "PROMOTIONS/SET_FILTERS",
        SET_FETCHING: "PROMOTIONS/SET_FETCHING",
        SET_SORT: "PROMOTIONS/SET_SORT",
        SET_PERSIST: "PROMOTIONS/SET_PERSIST",
    },
    CURRENT: {
        FETCH: progressTypes("CURRENT_PROMOTION"),
        CLEAR: "CURRENT_PROMOTION/CLEAR",
        ADD: "CURRENT_PROMOTION/ADD",
    },
};

export const LSID_IDENTITY_SET = "LSID_IDENTITY/SET";
export const LSID_IDENTITY_UPDATE = "LSID_IDENTITY/UPDATE";

export const DELIVERY_WINDOWS = {
    PREDEFINED: baseTypes("DELIVERY_WINDOWS/PREDEFINED"),
    REPLENISHMENT: baseTypes("DELIVERY_WINDOWS/REPLENISHMENT"),
};

export const CART_CONFIRMATION = {
    SET: "CART_CONFIRMATION/SET",
    DELETE: "CART_CONFIRMATION/DELETE",
};
export const MERCHANT_ENABLEMENTS = baseTypes("MERCHANT_ENABLEMENTS");

export const MERCHANT_ORGANIZATION = baseTypes("MERCHANT_ORGANIZATION");

export const LOADER = {
    SHOW: "LOADER/SHOW",
    HIDE: "LOADER/HIDE",
};
